<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-child_bk.png" alt="" width="19" height="25" />
      <p class="title-bk">生徒管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <!--tab-->
      <ul class="nav nav-tabs">
        <li class="nav-item" id="tabmenu">
          <a
            class="nav-link tabitem nav-cursor"
            :class="{ active: isNormalAccountTab }"
            @click="selectTab(TABS.NORMAL_ACCOUNT)"
          >
            生徒アカウント
          </a>
        </li>
        <li class="nav-item" id="tabmenu">
          <a
            class="nav-link tabitem nav-cursor"
            :class="{ active: isTrialAccountTab }"
            @click="selectTab(TABS.TRIAL_ACCOUNT)"
          >
            体験版アカウント
          </a>
        </li>
        <li class="nav-item" id="tabmenu">
          <a
            class="nav-link tabitem nav-cursor"
            :class="{ active: isClosedOrPreRegistrationAccountTab }"
            @click="selectTab(TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT)"
          >
            休会・仮登録アカウント
          </a>
        </li>
      </ul>

      <form class="form-inline d-flex justify-content-between">
        <div>
          <v-select
            tag="div"
            v-model="selectedFunction"
            placeholder="クリックして一括機能を選択 / 検索"
            class="form-control"
            id="dropdownMenuButton"
            :options="batchFunctions"
            :reduce="(option) => option.value"
            label="label"
          />
          <button type="button" class="btn-sm" @click="executeBatchFunction">実行</button>
          <button type="button" class="btn-sm" v-if="isNormalAccountTab" @click="createNewStudent">新規登録</button>
          <button
            type="button"
            class="btn-sm"
            v-if="isNormalAccountTab && !hasTeacherPrivilege"
            @click="bulkRegistration"
          >
            一括登録
          </button>
          <button type="button" class="btn-sm" v-if="isTrialAccountTab" @click="experienceRegistration">
            体験ID登録
          </button>
        </div>
        <div>
          <button type="button" class="btn btn-gray" @click="exportToExcel">エクスポート</button>
          <button type="button" class="btn btn-gray" @click="exportToPdf">プリント</button>
          <button type="button" class="btn btn-gray" @click="displayColumns">表示項目選択</button>
        </div>
      </form>

      <form class="search-box-container d-flex">
        <div class="search-box-left">
          <table v-if="hasAdminPrivilege || hasCorporationPrivilege || hasBrandPrivilege">
            <tr>
              <td width="4%" class="text-center">
                <img class="mr-2" :src="searchIcon()" alt="" />
              </td>
              <td v-if="hasAdminPrivilege" width="32%" class="pr-1">
                <v-select
                  tag="div"
                  v-model="selectedCorporation"
                  placeholder="法人名で絞り込む"
                  id="searchDropdownMenuButton"
                  class="select-control"
                  :options="corporation.corporations"
                  :reduce="(option) => option.id"
                  label="name"
                  @input="pickedCorporation"
                />
              </td>
              <td v-if="hasAdminPrivilege || hasCorporationPrivilege" width="32%" class="pr-1">
                <v-select
                  tag="div"
                  v-model="selectedBrand"
                  placeholder="ブランド名で絞り込む"
                  class="select-control"
                  :disabled="disableChoosingBrand"
                  :options="brand.brands"
                  :reduce="(option) => option.id"
                  label="name"
                  @input="pickedBrand"
                />
              </td>
              <td v-if="hasAdminPrivilege || hasCorporationPrivilege || hasBrandPrivilege" width="32%">
                <v-select
                  tag="div"
                  v-model="selectedSchool"
                  placeholder="教場名で絞り込む"
                  class="select-control"
                  :disabled="disableChoosingSchool"
                  :options="school.schools"
                  :reduce="(option) => option.id"
                  label="name"
                />
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td width="30%">
                <select
                  class="custom-select mr-sm-1"
                  id="inlineFormCustomSelectSmall"
                  v-model="perPage"
                  @change="perPageChanged($event)"
                >
                  <!-- <option :value="currentTotalStudents" selected>全</option> -->
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                  <option :value="150">150</option>
                </select>
                件表示
              </td>
            </tr>
          </table>
        </div>
        <div class="search-box-right">
          <table>
            <tr>
              <td v-if="hasSchoolPrivilege || hasTeacherPrivilege" width="4%">
                <img class="mr-2" :src="searchIcon()" alt="" />
              </td>
              <td width="40%" class="pr-1">
                <v-select
                  tag="div"
                  v-model="selectedSearchColumn"
                  id="searchDropdownMenuButton"
                  :clearable="false"
                  class="select-control"
                  :options="searchOptions"
                  :reduce="(option) => option.value"
                  label="label"
                  @input="unsetFilterValue()"
                />
              </td>
              <td width="30%" class="pr-1">
                <v-select
                  id="searchDropdownMenuButton"
                  v-if="selectedSearchColumn == 'hasNextTeachingMaterial'"
                  :disabled="disableSearchBox"
                  tag="div"
                  v-model="selectedFilterValue"
                  placeholder="選択してください"
                  class="select-control"
                  :options="nextTeachingMaterialDates"
                  label="text"
                >
                </v-select>
                <input
                  :disabled="disableSearchBox"
                  v-else
                  type="text"
                  id="searchform_small"
                  class="form-control"
                  v-model="selectedFilterValue"
                />
              </td>
              <td width="25%">
                <button type="button" class="btn-sm form-search-button" @click="searchByField()">検索</button>
              </td>
            </tr>
            <tr>
              <td v-if="hasSchoolPrivilege || hasTeacherPrivilege" width="4%"></td>
              <td width="30%">
                <b-form-radio-group
                  v-model="selectedOrderDirection"
                  :options="radioOptions"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                >
                </b-form-radio-group>
              </td>
              <td width="30%" class="pr-1">
                <v-select
                  tag="div"
                  id="searchDropdownMenuButton"
                  v-model="selectedOrderColumn"
                  :clearable="true"
                  class="select-control"
                  :options="sortOptions"
                  :reduce="(option) => option.value"
                  label="label"
                />
              </td>
              <td width="25%">
                <button type="button" class="btn-sm form-search-button" @click="orderByField()">並び替え</button>
              </td>
            </tr>
          </table>
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y my-custom-scrollbar">
            <b-table
              ref="student-table"
              :min-width="tableWidth"
              class="sticky-table table-auto-height"
              selectable
              responsive
              sticky-header
              :items="currentStudents"
              :fields="filteredHeaders"
              :filter="filter"
              :filterIncludedFields="searchableFields"
              :per-page="perPage"
              @row-selected="onRowSelected"
              :busy="currentBusyState"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:head(selected)>
                <b-form-checkbox @input="toggleSelectAll" v-model="selectAll" />
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox @input="selectRow($event, row.index)" v-model="row.rowSelected" />
              </template>

              <template v-slot:cell(status)="row">
                {{ basicPresent(row.value) }}
              </template>

              <template v-slot:cell(statusUpdateDate)="row">
                {{ basicPresent(row.value) }}
              </template>

              <template v-slot:cell(name)="row">
                <template v-if="isTrialAccountTab">
                  {{ row.value }}
                </template>
                <template v-else>
                  <router-link :to="{ name: 'student-id-detail', params: { id: row.item.id } }">
                    {{ row.value }}
                  </router-link>
                </template>
              </template>

              <template v-slot:cell(nextFiguredTeachingMaterialMonth)="row">
                {{ nextFiguredTeachingMaterialMonth(row.item.nextFiguredTeachingMaterials) }}
              </template>

              <template v-slot:cell(preRegistrationStatus)="row">
                {{ preRegistrationStatusDisplay(row.item) }}
              </template>

              <template v-slot:cell(preRegistrationDatetime)="row">
                {{ preRegistrationDatetimePresent(row.value) }}
              </template>

              <template v-slot:cell(preRegistrationDateStatus)="row">
                {{ preRegistrationDateStatusDisplay(row.item) }}
              </template>

              <template v-slot:cell(deactivatedDatetime)="row">
                {{ deactivatedDatetimePresent(row.value) }}
              </template>

              <template v-slot:cell(reactivatedDatetime)="row">
                {{ reactivatedDatetimePresent(row.value) }}
              </template>

              <template v-slot:cell(trialExpirationDatetime)="row">
                {{ trialExpirationDatetimePresent(row.value) }}
              </template>

              <template v-slot:cell(remainingDaysToDelete)="row">
                {{ remainingDaysToDeletePresent(row.item) }}
              </template>

              <template v-slot:cell(learningHistory)="row">
                <button type="button" class="btn-sm" @click="showLearningHistory(row.item.id)">学習履歴</button>
              </template>

              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>データのロード...</strong>
                </div>
              </template>
            </b-table>
          </div>
          <div class="pagination-footer">
            <label> {{ currentTotalStudentsWithLazyLoading }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
            <div class="float-right">
              <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
                前
              </button>
              <label class="pagination-border text-center">{{ currentPage }}</label>
              <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">次</button>
            </div>
          </div>
        </div>
      </div>
      <PopUpHolder
        ref="not_selected"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="閉じる"
        @greenClick="notSelectedConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>操作を行う生徒が選択されていません。</template>
      </PopUpHolder>
      <PopUpHolder
        ref="upgrade_level_error"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="戻る"
        @greenClick="upgradeLevelErrorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          選択した教材を学習していないか、これ以上進級できない<br />
          生徒が含まれています。チェックをつけた生徒を再確認してください。
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="downgrade_level_error"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="戻る"
        @greenClick="downgradeLevelErrorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          選択した教材を学習していないか、これ以上進級取消できない<br />
          生徒が含まれています。チェックをつけた生徒を再確認してください。
        </template>
      </PopUpHolder>

      <PopUpHolder
        ref="deactivate_error"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="戻る"
        @greenClick="deactivateErrorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          指定した休会開始月になったため実行できません。<br />
          翌月以降の休会開始月を選択して実行してください。
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="change_next_figured_teaching_material_error"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="戻る"
        @greenClick="changeNextFiguredTeachingMaterialErrorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          変更先の教材が選択されていないため実行できません。<br />
          教材を1つ以上選択して実行してください。
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="comfirmisImmediate"
        no-close-on-esc
        no-close-on-backdrop
        show-red-button
        green-button-title="戻る"
        red-button-title="実行"
        @greenClick="changeNextFiguredTeachingMaterialPopup"
        @redClick="confirmisImmediate"
      >
        <template v-slot:header>教材変更予約</template>
        <template v-slot:body>
          <div class="caution">
            即日変更を実行します<br />
            ※選択している生徒の<span>利用教材が即時に切り替わり、来月からの教材予約が全てキャンセル</span>されます。<br />
          </div>
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="deactivate_select_error"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="戻る"
        @greenClick="deactivateErrorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          休会開始月が選択されていません。<br />
          休会開始月を選択してください。
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="select_downgrade_level"
        :popup-size="selectedFunctionSize"
        show-red-button
        no-close-on-esc
        no-close-on-backdrop
        red-button-title="次に進む"
        green-button-title="戻る"
        @redClick="selectDowngradeLevelConfirmed"
        @greenClick="downgradeLevelFunctionRejected"
      >
        <template v-slot:header>進級取消</template>
        <template v-slot:body>
          <template>
            <div class="form-inline">
              進級取消対象の教材を選択してください。
            </div>
            <div class="downgrade-level-radio-group">
              <div class="radio" v-for="materialLevel in materialLevels" :key="materialLevel.name">
                <input
                  class="radio-input"
                  type="radio"
                  name="materialLevel"
                  :id="materialLevel.name"
                  :value="materialLevel"
                  v-model="selectedMaterialLevel"
                />
                <label class="radio-label" :for="materialLevel.name">
                  {{ materialLevel.name }}
                </label>
              </div>
            </div>
          </template>
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="downgrade_level_select_error"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="戻る"
        @greenClick="downgradeLevelErrorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          進級取消対象の教材が選択されていません。<br />
          教材を選択してください。
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="selected_function"
        :popup-size="selectedFunctionSize"
        show-red-button
        no-close-on-esc
        no-close-on-backdrop
        red-button-title="実行"
        green-button-title="戻る"
        @redClick="selectedFunctionConfirmed"
        @greenClick="selectedFunctionRejected"
      >
        <template v-slot:header v-if="isPdfOutputPopup">生徒用お知らせPDF出力</template>
        <template v-slot:header v-else-if="isDeactivatePopup">休会予約</template>
        <template v-slot:header v-else-if="isReactivatePopup">休会予約キャンセル</template>
        <template v-slot:header v-else-if="isUpgradeLevel1Popup">進級（図形の極）</template>
        <template v-slot:header v-else-if="isUpgradeLevel31Popup">進級（中学生の図形の極 – 平面）</template>
        <template v-slot:header v-else-if="isUpgradeLevel32Popup">進級（中学生の図形の極 – 空間）</template>
        <template v-slot:header v-else-if="isUpgradeLevel3Popup">進級（中学生の図形の極 – Grade4以上）</template>
        <template v-slot:header v-else-if="isUpgradeLevel2Popup">進級（数の極）</template>
        <template v-slot:header v-else-if="isUpgradeLevel4Popup">進級（中学生の代数の極）</template>
        <template v-slot:header v-else-if="isUpgradeLevel7Popup">進級（魔法の国語）</template>
        <template v-slot:header v-else-if="isUpgradeLevel6Popup">進級（遊）</template>
        <template v-slot:header v-else-if="isUpgradeLevel5Popup">進級（数学の悟）</template>
        <template v-slot:header v-else-if="isDowngradeLevelPopup"
          >進級取消（{{ selectedMaterialLevel ? selectedMaterialLevel.name : '-' }}）</template
        >
        <template v-slot:header v-else-if="isChangeNextFiguredTeachingMaterialPopup">教材変更予約</template>
        <template v-slot:header v-else-if="isClearNextFiguredTeachingMaterialPopup">教材変更予約キャンセル</template>
        <template v-slot:header v-else-if="isChangePreRegistrationTimePopup">利用開始予約</template>
        <template v-slot:header v-else-if="isClearPreRegistrationTimePopup">利用開始予約キャンセル</template>
        <template v-slot:header v-else-if="isChangeFiguredTeachingMaterialPopup">教材変更</template>
        <template v-slot:body>
          <template v-if="isPdfOutputPopup">
            <div class="form-inline">
              この機能を実行すると、選択している生徒のパスワードがリセットされ、新しいパスワードが発行されます。
            </div>
          </template>
          <template v-else-if="isDeactivatePopup">
            <div class="form-inline">選択されている生徒に対して休会予約をします</div>
            <div>
              <div>
                休会開始月：
                <v-select
                  tag="div"
                  v-model="deactivateMonth"
                  placeholder="選択してください"
                  class="custom-select mr-sm-2"
                  id="inlineFormCustomSelect-2"
                  style="width: 170px;"
                  :clearable="false"
                  :options="deactivateMonthJPs"
                  :reduce="(option) => option.value"
                  label="text"
                />
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ 休会開始月を「{{ nextMonthJP }}」とした場合、{{ endOfCurrentMonthJP }}までは学習することができます。
                </small>
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ {{ nextMonthJP }}から学習できなくなり、{{ nextMonthJP }}の課金ID数にもカウントされません。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isReactivatePopup">
            <div>
              <div>選択されている生徒に対して休会予約を取り消します</div>
              <div>
                <small class="text-danger small-text">
                  ※ 休会開始月が登録されていない生徒を選択している場合、その生徒には何の処理も行われません。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isUpgradingLevelPopup">
            <div>
              <div>選択されている生徒に対して、1つ上の級に進級させる処理を</div>
              <div>実行します</div>
              <template v-if="isUpgradeLevel3Popup">
                <div>平面図形と空間図形が両方G3でない場合、G4には進級できません。</div>
              </template>
            </div>
          </template>
          <template v-else-if="isDowngradeLevelPopup">
            <div>
              <div>選択されている生徒に対して、1つ前の級に戻す処理を実行します</div>
            </div>
          </template>
          <template v-else-if="isChangeNextFiguredTeachingMaterialPopup">
            <div class="form-inline">選択されている生徒の教材の変更を予約します</div>
            <div>
              <div class="material-checkbox">
                {{ nextMonthJP }}から受講する教材を選択：
                <TeachingMaterialCheckBox
                  inputClass="col-lg-8"
                  :options="teachingMaterialOptions"
                  optionValue="code"
                  optionLabel="name"
                  v-model="nextTeachingMaterialCodes"
                  :checkedLists="nextTeachingMaterialCodes"
                  :disableBoxes="isImmediate"
                />
                <div v-if="hasAdminPrivilege">
                  即日変更：
                  <label class="nav-cursor">
                    <input
                      type="checkbox"
                      v-model="isImmediate"
                      :disabled="!hasSelectedNextTeachingMaterial(nextTeachingMaterialCodes)"
                    />
                    即日変更
                  </label>
                </div>
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ {{ startOfNextMonthJP }}に、選択されている生徒の教材がリストから選んだ教材に上書きされます。
                </small>
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ リストから2教材を選んだ場合は、2教材分のID利用料が来月より発生します。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isClearNextFiguredTeachingMaterialPopup">
            <div>
              <div>選択されている生徒の教材の変更を取り消します</div>
              <div>
                <small class="text-danger small-text">
                  ※ 取り消した場合、{{ nextMonthJP }}からも引き続き同じ教材で学習します。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isChangePreRegistrationTimePopup">
            <div class="form-inline">選択されている生徒に対して利用開始月を予約します</div>
            <div>
              <div>
                利用開始月：
                <v-select
                  tag="div"
                  v-model="preRegistrationMonth"
                  placeholder="選択してください"
                  class="custom-select mr-sm-2"
                  id="inlineFormCustomSelect-2"
                  style="width: 170px;"
                  :clearable="false"
                  :options="preRegistrationMonthJPs"
                  :reduce="(option) => option.value"
                  label="text"
                />
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ 利用開始月を「{{ nextMonthJP }}」とした場合、{{ startOfNextMonthJP }}から学習することができます。
                </small>
              </div>
              <div>
                <small class="text-danger small-text"> ※ {{ nextMonthJP }}の課金ID数にカウントされます。 </small>
              </div>
            </div>
          </template>
          <template v-else-if="isClearPreRegistrationTimePopup">
            <div>
              <div>選択されている生徒に対して利用開始月の予約を取り消します</div>
              <div>
                <small class="text-danger small-text">
                  ※ 利用開始月予約が登録されていない生徒を選択している場合、その生徒には何の処理も行われません。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isChangeFiguredTeachingMaterialPopup">
            <div class="form-inline">選択されている生徒の教材を変更します</div>
            <div>
              <div>
                <div class="material-checkbox">
                  変更する教材を選択：
                  <TeachingMaterialCheckBox
                    inputClass="col-lg-8"
                    :options="teachingMaterialOptions"
                    optionValue="code"
                    optionLabel="name"
                    v-model="nextTeachingMaterialCodes"
                    :checkedLists="nextTeachingMaterialCodes"
                  />
                </div>
              </div>
              <div>
                <small class="text-danger small-text"> ※ 変更した教材は、利用開始月よりお使いいただけます。 </small>
              </div>
            </div>
          </template>
          <div class="form-inline">選択されている生徒ID数：{{ selectedStudentSize }}</div>
          <div class="tab-content">
            <div id="table-1" class="tab-pane active">
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <b-table
                  ref="student-popup-table"
                  responsive
                  sticky-header
                  :items="selected"
                  :fields="selectedFunctionFields"
                  :per-page="perPageSelected"
                  :current-page="currentPageSelected"
                >
                  <template v-slot:head()="scope">
                    <div class="text-nowrap">
                      <b>{{ scope.label }}</b>
                    </div>
                  </template>

                  <template v-slot:cell(preLevelUpdate)="row">
                    {{ levelDisplay(row.item.levels) }}
                  </template>

                  <template v-slot:cell(expectedLevelUpgrade)="row">
                    {{ expectedLevelUpgradeDisplay(row.item.levels) }}
                  </template>

                  <template v-slot:cell(expectedLevelDowngrade)="row">
                    {{ expectedLevelDowngradeDisplay(row.item.levels) }}
                  </template>

                  <template v-slot:cell(figuredShapeTeachingMaterial)="row">
                    {{ figuredShapeTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredAlgebraTeachingMaterial)="row">
                    {{ figuredAlgebraTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredJapaneseTeachingMaterial)="row">
                    {{ figuredJapaneseTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredKidsMathematicsTeachingMaterial)="row">
                    {{ figuredKidsMathematicsTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredAdvancedMathematicsTeachingMaterial)="row">
                    {{ figuredAdvancedMathematicsTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredShapeTeachingMaterial)="row">
                    {{ figuredShapeTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredAlgebraTeachingMaterial)="row">
                    {{ figuredAlgebraTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredJapaneseTeachingMaterial)="row">
                    {{ figuredJapaneseTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredKidsMathematicsTeachingMaterial)="row">
                    {{ figuredKidsMathematicsTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredAdvancedMathematicsTeachingMaterial)="row">
                    {{ figuredAdvancedMathematicsTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(preRegistrationDatetime)="row">
                    {{ preRegistrationDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(deactivatedDatetime)="row">
                    {{ deactivatedDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(reactivatedDatetime)="row">
                    {{ reactivatedDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(trialExpirationDatetime)="row">
                    {{ trialExpirationDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(preRegistrationStatus)="row">
                    {{ preRegistrationStatusDisplay(row.item) }}
                  </template>

                  <template v-slot:cell(currentTeachingMaterialGraphic)="row">
                    {{ basicPresent(row.value) }}
                  </template>

                  <template v-slot:cell(currentTeachingMaterialNumber)="row">
                    {{ basicPresent(row.value) }}
                  </template>
                </b-table>
              </div>
              <div class="pagination-footer">
                <div class="float-right">
                  <button
                    :disabled="!hasPreviousPageSelected"
                    type="button"
                    class="btn btn-invisible"
                    @click="goToPreviousPageSelected"
                  >
                    前
                  </button>
                  <label class="pagination-border text-center">{{ currentPageSelected }}</label>
                  <button
                    :disabled="!hasNextPageSelected"
                    type="button"
                    class="btn btn-invisible"
                    @click="goToNextPageSelected"
                  >
                    次
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="selected_result_function"
        :popup-size="selectedFunctionSize"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="閉じる"
        @greenClick="resultFunctionConfirmed"
      >
        <template v-slot:header v-if="isDeactivatePopup">休会予約</template>
        <template v-slot:header v-else-if="isReactivatePopup">休会予約キャンセル</template>
        <template v-slot:header v-else-if="isUpgradeLevel1Popup">進級（図形の極）</template>
        <template v-slot:header v-else-if="isUpgradeLevel31Popup">進級（中学生の図形の極 – 平面）</template>
        <template v-slot:header v-else-if="isUpgradeLevel32Popup">進級（中学生の図形の極 – 空間）</template>
        <template v-slot:header v-else-if="isUpgradeLevel3Popup">進級（中学生の図形の極 – Grade4以上）</template>
        <template v-slot:header v-else-if="isUpgradeLevel2Popup">進級（数の極）</template>
        <template v-slot:header v-else-if="isUpgradeLevel4Popup">進級（中学生の代数の極）</template>
        <template v-slot:header v-else-if="isUpgradeLevel7Popup">進級（魔法の国語）</template>
        <template v-slot:header v-else-if="isUpgradeLevel6Popup">進級（遊）</template>
        <template v-slot:header v-else-if="isUpgradeLevel5Popup">進級（数学の悟）</template>
        <template v-slot:header v-else-if="isDowngradeLevelPopup"
          >進級取消（{{ selectedMaterialLevel ? selectedMaterialLevel.name : '-' }}）</template
        >
        <template v-slot:header v-else-if="isChangeNextFiguredTeachingMaterialPopup">教材変更予約</template>
        <template v-slot:header v-else-if="isClearNextFiguredTeachingMaterialPopup"> 教材変更予約キャンセル </template>
        <template v-slot:header v-else-if="isChangePreRegistrationTimePopup">利用開始予約</template>
        <template v-slot:header v-else-if="isClearPreRegistrationTimePopup">利用開始予約キャンセル</template>
        <template v-slot:header v-else-if="isChangeFiguredTeachingMaterialPopup">教材変更</template>
        <template v-slot:body>
          <template>
            <div class="form-inline">完了しました！</div>
          </template>
          <template v-if="isChangeNextFiguredTeachingMaterialPopup">
            <div v-if="isImmediate">
              <div>
                即日変更した教材：
                {{ nextTeachingMaterialDisplay }}
              </div>
            </div>
            <div v-else>
              <div>
                {{ nextMonthJP }}から受講する教材を選択：
                {{ nextTeachingMaterialDisplay }}
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ {{ startOfNextMonthJP }}に、選択されている生徒の教材がリストから選んだ教材に上書きされます。
                </small>
              </div>
              <div>
                <small class="text-danger small-text">
                  ※ リストから2教材を選んだ場合は、2教材分のID利用料が来月より発生します。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isClearNextFiguredTeachingMaterialPopup">
            <div>
              <div>
                <small class="text-danger small-text">
                  ※ 取り消した場合、{{ nextMonthJP }}からも引き続き同じ教材で学習します。
                </small>
              </div>
            </div>
          </template>
          <template v-else-if="isChangeFiguredTeachingMaterialPopup">
            <div>
              <div>変更後の教材：{{ nextTeachingMaterialDisplay }}</div>
              <div>
                <small class="text-danger small-text"> ※ 変更した教材は、利用開始月よりお使いいただけます。 </small>
              </div>
            </div>
          </template>
          <small class="text-info" v-if="noticeMsg">{{ noticeMsg }}</small>
          <div class="form-inline">
            実行した生徒ID数：{{
              isUpgradingLevelPopup || isDowngradeLevelPopup ? filteredSelected.length : selectedStudentSize
            }}
          </div>
          <div class="tab-content">
            <div id="table-1" class="tab-pane active">
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <b-table
                  ref="student-popup-table"
                  responsive
                  sticky-header
                  :items="isUpgradingLevelPopup || isDowngradeLevelPopup ? filteredSelected : selected"
                  :fields="selectedFunctionFields"
                  :per-page="perPageSelected"
                  :current-page="currentPageSelected"
                >
                  <template v-slot:head()="scope">
                    <div class="text-nowrap">
                      <b>{{ scope.label }}</b>
                    </div>
                  </template>

                  <template v-slot:cell(postLevelUpdate)="row">
                    {{ postLevelUpdateDisplay(row.item.levels) }}
                  </template>

                  <template v-slot:cell(figuredShapeTeachingMaterial)="row">
                    {{ figuredShapeTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredAlgebraTeachingMaterial)="row">
                    {{ figuredAlgebraTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredJapaneseTeachingMaterial)="row">
                    {{ figuredJapaneseTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredKidsMathematicsTeachingMaterial)="row">
                    {{ figuredKidsMathematicsTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(figuredAdvancedMathematicsTeachingMaterial)="row">
                    {{ figuredAdvancedMathematicsTeachingMaterialDisplay(row.item.currentLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredTeachingMaterialMonth)="row">
                    {{ nextFiguredTeachingMaterialMonth(row.item.nextFiguredTeachingMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredShapeTeachingMaterial)="row">
                    {{ figuredShapeTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredAlgebraTeachingMaterial)="row">
                    {{ figuredAlgebraTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredJapaneseTeachingMaterial)="row">
                    {{ figuredJapaneseTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredKidsMathematicsTeachingMaterial)="row">
                    {{ figuredKidsMathematicsTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(nextFiguredAdvancedMathematicsTeachingMaterial)="row">
                    {{ figuredAdvancedMathematicsTeachingMaterialDisplay(row.item.nextLevelMaterials) }}
                  </template>

                  <template v-slot:cell(previousFiguredShapeTeachingMaterial)="row">
                    {{ figuredShapeTeachingMaterialDisplay(row.item.previousLevelMaterials) }}
                  </template>

                  <template v-slot:cell(previousFiguredAlgebraTeachingMaterial)="row">
                    {{ figuredAlgebraTeachingMaterialDisplay(row.item.previousLevelMaterials) }}
                  </template>

                  <template v-slot:cell(previousFiguredJapaneseTeachingMaterial)="row">
                    {{ figuredJapaneseTeachingMaterialDisplay(row.item.previousLevelMaterials) }}
                  </template>

                  <template v-slot:cell(previousFiguredKidsMathematicsTeachingMaterial)="row">
                    {{ figuredKidsMathematicsTeachingMaterialDisplay(row.item.previousLevelMaterials) }}
                  </template>

                  <template v-slot:cell(previousFiguredAdvancedMathematicsTeachingMaterial)="row">
                    {{ figuredAdvancedMathematicsTeachingMaterialDisplay(row.item.previousLevelMaterials) }}
                  </template>

                  <template v-slot:cell(preRegistrationDatetime)="row">
                    {{ preRegistrationDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(deactivatedDatetime)="row">
                    {{ deactivatedDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(reactivatedDatetime)="row">
                    {{ reactivatedDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(trialExpirationDatetime)="row">
                    {{ trialExpirationDatetimePresent(row.value) }}
                  </template>

                  <template v-slot:cell(nextPreRegistrationStatus)="row">
                    {{ nextPreRegistrationStatusDisplay(row.item) }}
                  </template>

                  <template v-slot:cell(currentTeachingMaterialGraphic)="row">
                    {{ basicPresent(row.value) }}
                  </template>

                  <template v-slot:cell(currentTeachingMaterialNumber)="row">
                    {{ basicPresent(row.value) }}
                  </template>
                </b-table>
              </div>
              <div class="pagination-footer">
                <div class="float-right">
                  <button
                    :disabled="!hasPreviousPageSelected"
                    type="button"
                    class="btn btn-invisible"
                    @click="goToPreviousPageSelected"
                  >
                    前
                  </button>
                  <label class="pagination-border text-center">{{ currentPageSelected }}</label>
                  <button
                    :disabled="!hasNextPageSelected"
                    type="button"
                    class="btn btn-invisible"
                    @click="goToNextPageSelected"
                  >
                    次
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </PopUpHolder>
      <PopUpHolder ref="bulk_registration" no-close-on-esc no-close-on-backdrop custom-footer>
        <template v-slot:header>
          生徒一括登録
          <div class="float-right">
            <button class="btn-image ml-auto">
              <img
                src="@/assets/images/Icon metro-cross_bk.png"
                alt=""
                width="20"
                height="20"
                @click="dismissBulkRegistrationPopup"
              />
            </button>
          </div>
          <hr class="divide-line" />
        </template>
        <template v-slot:body>
          <p>
            1. 入力フォーム（Excelファイル）を下のリンクからダウンロードしてください
            <span class="small-sub-text"><a href="/csv/AAA_import_student_v5.xlsx">AAA_import_student_v5.xlsx</a></span>
          </p>
          <p>
            2. エクセル等で入力フォームに必要なデータを入力してください
            <br />
            <small class="text-danger small-text">
              ※ ファイルは必ず「CSV UTF-8 (コンマ区切り)（*.csv）」として保存してください
              <span class="small-sub-text">エクセル形式（.xls / .xlsx）では文字化けを起こす可能性があります</span>
            </small>
            <small class="text-danger small-text">
              ※ ヘッダー（1行目のタイトル行）は編集しないでください
              <span class="small-sub-text">正常に読み込みができない可能性があります</span>
            </small>
          </p>
          <p>
            3. データを入力したcsvファイルをアップロードしてください
            <span class="small-sub-text">
              <FileReader @contentLoaded="contentLoaded" file-type=".csv" />
            </span>
          </p>
          <p>4. 右下の[ 取り込み ] を押してください</p>
        </template>
        <template v-slot:footer>
          <button
            type="button"
            class="btn btn-confirm-bulk"
            :disabled="csvHashContent.length == 0"
            @click="bulkRegistrationConfirmed"
          >
            取り込み
          </button>
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_import_failed"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="dismissBulkRegistrationPopup"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>
          <div class="caution">
            以下生徒のパスワード入力値が<span>数字と英字を最低1つ含む4文字以上</span>となっているか、もう一度お確かめください<br /><br />
          </div>
          <div v-for="(inValidImportStudent, index) in inValidImportStudentList" :key="index">
            <span>・{{ inValidImportStudent.name }}<br /></span>
          </div>
        </template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>表示する項目を選択してください</template>
        <template v-slot:body>
          <thead>
            <tr v-for="field in customHeaders" :key="field.key">
              <th scope="row">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :id="field.key" v-model="field.enable" />
                  <label class="custom-control-label" :for="field.key">
                    {{ field.label }}
                  </label>
                </div>
              </th>
            </tr>
          </thead>
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { endOfCurrentMonthJP, startOfNextMonthJP, nextMonthJP, nextNMonthJPs } from '@/utils/year_helpers';
import { currentDayJP, secondsDiff } from '@/utils/date_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import FileReader from '@/components/files/FileReader.vue';
import TeachingMaterialCheckBox from '@/components/forms/TeachingMaterialCheckBox.vue';
import { updateTableHeight } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import {
  basicPresent,
  basicJapaneseYearMonth,
  basicLevelDisplay,
  basicNextTeachingMaterialMonth,
  basicFieldPresent,
  basicTeachingMaterialShapeDisplay,
  basicTeachingMaterialAlgebraDisplay,
  basicTeachingMaterialJapaneseDisplay,
  basicTeachingMaterialKidsMathematicsDisplay,
  basicTeachingMaterialAdvancedMathematicsDisplay,
  basicDate,
  basicDatetime,
  remainingDaysToDeletePresent,
  basicTrialStudentNameIdPresent,
  preRegistrationStatusDisplay,
  preRegistrationDateStatusDisplay,
} from '@/presenters/fields';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { csvParser } from '@/utils/file_helpers.js';
import { keyConvert } from '@/utils/hash_helpers.js';
import { filterTeachingMaterialsByProducts } from '@/utils/teaching_material_helpers';
import find from 'lodash/find';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { buildJapaneseFont } from '@/helpers/PdfCustomFont.js';

export default {
  components: {
    PopUpHolder,
    FileReader,
    TeachingMaterialCheckBox,
  },
  data() {
    var TABS = {
      NORMAL_ACCOUNT: 'normal_account',
      TRIAL_ACCOUNT: 'trial_account',
      CLOSED_OR_PRE_REGISTRATION_ACCOUNT: 'closed_or_pre_registration_account',
    };
    return {
      fields: [],
      deactivateMonth: null,
      isImmediate: false,
      nextTeachingMaterialCodes: [],
      preRegistrationMonth: null,
      currentPage: 1,
      currentStudentPage: 1,
      currentTrialStudentPage: 1,
      currentCloseOrPreRegistrationStudentPage: 1,
      offset: 0,
      perPage: 50,
      perStudentPage: 50,
      perTrialStudentPage: 50,
      perClosedOrPreRegistrationStudentPage: 50,
      currentPageSelected: 1,
      perPageSelected: 50,
      selectAll: false,
      selected: [],
      filteredSelected: [],
      preUpdateSelected: [],
      batchFunctions: [],
      sortOptions: [],
      searchOptions: [],
      radioOptions: [],
      nextTeachingMaterialDates: [],
      selectedFunctionFields: [],
      selectedFunction: null,
      selectedCorporation: null,
      selectedBrand: null,
      selectedSchool: null,
      selectedOrderColumn: null,
      selectedOrderDirection: 'ASC', //default sort direction
      selectedSearchColumn: null, // selected column name for the search (not yet applied)
      selectedFilterValue: null, // selected value for the search (not yet applied)
      appliedFilterBy: null, // type: object, currently effective filter applied to the list
      appliedOrderBy: null, // type: object, currently effective order / sort applied to the list
      filter: null,
      TABS,
      currentTab: TABS.NORMAL_ACCOUNT,
      csvHashContent: [],
      normalBusy: true,
      trialBusy: true,
      closedOrPreRegistrationBusy: true,
      normalLazyLoadingDone: false,
      trialLazyLoadingDone: false,
      closedOrPreRegistrationLazyLoadingDone: false,
      pagingLoadingDone: false,
      DEFAULT_LIMIT_FIRST_REQUEST: 50,
      DEFAULT_OFFSET_FIRST_REQUEST: 0,
      DEFAULT_SEARCH_COLUMN: '検索項目を選択',
      DEFAULT_SORT_DIRECTION: 'ASC',
      noticeMsg: '',
      teachingMaterialOptions: [],
      inValidImportStudentList: [],
      materialLevels: [
        { materialCode: '400', level: 'level_1', levelPosition: 0, subLevelPosition: null, name: '図形の極' },
        {
          materialCode: '100',
          level: 'level_3.1',
          levelPosition: 4,
          subLevelPosition: 0,
          name: '中学生の図形の極 – 平面',
        },
        {
          materialCode: '100',
          level: 'level_3.2',
          levelPosition: 4,
          subLevelPosition: 1,
          name: '中学生の図形の極 – 空間',
        },
        {
          materialCode: '101',
          level: 'level_3',
          levelPosition: 4,
          subLevelPosition: null,
          name: '中学生の図形の極 – Grade4以上',
        },
        { materialCode: '200', level: 'level_2', levelPosition: 1, subLevelPosition: null, name: '数の極' },
        {
          materialCode: '300',
          level: 'level_4',
          levelPosition: 5,
          subLevelPosition: null,
          name: '中学生の代数の極',
        },
        { materialCode: '700', level: 'level_7', levelPosition: 6, subLevelPosition: null, name: '魔法の国語' },
        { materialCode: '600', level: 'level_6', levelPosition: 3, subLevelPosition: null, name: '遊' },
        { materialCode: '500', level: 'level_5', levelPosition: 2, subLevelPosition: null, name: '数学の悟' },
      ],
      selectedMaterialLevel: null,
    };
  },
  async mounted() {
    this.initNomalAccountTab();
    this.initSearchAndSortFeature();

    // 登録・編集の入力情報を初期化
    this.clearEditingStudentAffiliation();
    this.clearEditingStudent();
    this.$store.dispatch('form/clearFormDataStored');

    // initialize all tabs and the first 50 data per tab
    let params = { limit: this.DEFAULT_LIMIT_FIRST_REQUEST, offset: this.DEFAULT_OFFSET_FIRST_REQUEST, setBusy: true };
    await this.loadNormalStudents(params);
    await this.loadTrialStudents(params);
    await this.loadClosedOrPreRegistrationStudents(params);

    this.pagingLoadingDone = true;
    this.normalLazyLoadingDone = true;
    this.trialLazyLoadingDone = true;
    this.closedOrPreRegistrationLazyLoadingDone = true;

    this.teachingMaterialOptions = await this.filterTeachingMaterialsByProducts();
  },
  computed: {
    endOfCurrentMonthJP() {
      return endOfCurrentMonthJP();
    },
    startOfNextMonthJP() {
      return startOfNextMonthJP();
    },
    nextMonthJP() {
      return nextMonthJP();
    },
    disableChoosingBrand() {
      return this.selectedCorporation == null;
    },
    disableChoosingSchool() {
      return this.selectedBrand == null;
    },
    disableSearchBox() {
      return this.selectedSearchColumn == null || this.selectedSearchColumn == this.DEFAULT_SEARCH_COLUMN;
    },
    deactivateMonthJPs() {
      let numberOfMonths = 12;
      if (Vue.config.stagingBuild) {
        return nextNDayJPs(numberOfMonths);
      }
      return nextNMonthJPs(numberOfMonths);
    },
    preRegistrationMonthJPs() {
      let numberOfMonths = 5;
      let arrayOfMonths = [];
      if (Vue.config.stagingBuild) {
        arrayOfMonths = nextNDayJPs(numberOfMonths);
      } else {
        arrayOfMonths = nextNMonthJPs(numberOfMonths);
      }
      arrayOfMonths.unshift({
        value: 'now',
        text: '今すぐ利用開始',
      });
      return arrayOfMonths;
    },
    isNormalAccountTab() {
      return this.currentTab == this.TABS.NORMAL_ACCOUNT;
    },
    isTrialAccountTab() {
      return this.currentTab == this.TABS.TRIAL_ACCOUNT;
    },
    isClosedOrPreRegistrationAccountTab() {
      return this.currentTab == this.TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT;
    },
    currentBusyState() {
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          return this.normalBusy;
        case this.TABS.TRIAL_ACCOUNT:
          return this.trialBusy;
        case this.TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT:
        default:
          return this.closedOrPreRegistrationBusy;
      }
    },
    hasAdminPrivilege() {
      return this.hasAdminPrivilege;
    },
    hasTeacherPrivilege() {
      return this.hasTeacherPrivilege;
    },
    hasCorporationPrivilege() {
      return this.hasCorporationPrivilege;
    },
    hasBrandPrivilege() {
      return this.hasBrandPrivilege;
    },
    hasSchoolPrivilege() {
      return this.hasSchoolPrivilege;
    },
    selectedStudentSize() {
      return this.selected.length;
    },
    selectedFunctionSize() {
      let popupSize = null;
      switch (this.selectedFunction) {
        case 'deactivatePopup':
        case 'reactivatePopup':
        case 'changeNextFiguredTeachingMaterialPopup':
        case 'clearNextFiguredTeachingMaterialPopup':
        case 'changeFiguredTeachingMaterialPopup':
          popupSize = 'lg';
          break;
      }
      return popupSize;
    },
    isPdfOutputPopup() {
      return this.selectedFunction === 'pdfOutputPopup';
    },
    isDeactivatePopup() {
      return this.selectedFunction === 'deactivatePopup';
    },
    isReactivatePopup() {
      return this.selectedFunction === 'reactivatePopup';
    },
    isUpgradeLevel1Popup() {
      return this.selectedFunction === 'upgradeLevel1Popup';
    },
    isUpgradeLevel31Popup() {
      return this.selectedFunction === 'upgradeLevel31Popup';
    },
    isUpgradeLevel32Popup() {
      return this.selectedFunction === 'upgradeLevel32Popup';
    },
    isUpgradeLevel3Popup() {
      return this.selectedFunction === 'upgradeLevel3Popup';
    },
    isUpgradeLevel2Popup() {
      return this.selectedFunction === 'upgradeLevel2Popup';
    },
    isUpgradeLevel4Popup() {
      return this.selectedFunction === 'upgradeLevel4Popup';
    },
    isUpgradeLevel7Popup() {
      return this.selectedFunction === 'upgradeLevel7Popup';
    },
    isUpgradeLevel6Popup() {
      return this.selectedFunction === 'upgradeLevel6Popup';
    },
    isUpgradeLevel5Popup() {
      return this.selectedFunction === 'upgradeLevel5Popup';
    },
    isDowngradeLevelPopup() {
      return this.selectedFunction === 'downgradeLevelPopup';
    },
    isUpgradingLevelPopup() {
      return (
        this.selectedFunction === 'upgradeLevel1Popup' ||
        this.selectedFunction === 'upgradeLevel31Popup' ||
        this.selectedFunction === 'upgradeLevel32Popup' ||
        this.selectedFunction === 'upgradeLevel3Popup' ||
        this.selectedFunction === 'upgradeLevel2Popup' ||
        this.selectedFunction === 'upgradeLevel4Popup' ||
        this.selectedFunction === 'upgradeLevel6Popup' ||
        this.selectedFunction === 'upgradeLevel5Popup' ||
        this.selectedFunction === 'upgradeLevel7Popup'
      );
    },
    isChangeNextFiguredTeachingMaterialPopup() {
      return this.selectedFunction === 'changeNextFiguredTeachingMaterialPopup';
    },
    isClearNextFiguredTeachingMaterialPopup() {
      return this.selectedFunction === 'clearNextFiguredTeachingMaterialPopup';
    },
    isChangePreRegistrationTimePopup() {
      return this.selectedFunction === 'changePreRegistrationTimePopup';
    },
    isClearPreRegistrationTimePopup() {
      return this.selectedFunction === 'clearPreRegistrationTimePopup';
    },
    isChangeFiguredTeachingMaterialPopup() {
      return this.selectedFunction === 'changeFiguredTeachingMaterialPopup';
    },
    baseIndex() {
      if (this.currentStudents.length > 0) {
        return this.offset + 1;
      } else {
        return 0;
      }
    },
    capIndex() {
      if (this.baseIndex > 0 && this.pagingLoadingDone) {
        return this.baseIndex + this.currentStudents.length - 1;
      } else {
        return ' - ';
      }
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.currentTotalStudents > this.currentPage * this.perPage;
    },
    hasPreviousPageSelected() {
      return this.currentPageSelected > 1;
    },
    hasNextPageSelected() {
      return this.selectedStudentSize > this.currentPageSelected * this.perPageSelected;
    },
    customHeaders() {
      return this.fields.filter((field) => field.hidable == true);
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    nextTeachingMaterialDisplay() {
      return this.getTeachingMaterialNamesByCodes(this.nextTeachingMaterialCodes);
    },
    currentStudents() {
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          return this.student.students;
        case this.TABS.TRIAL_ACCOUNT:
          return this.student.trialStudents;
        default:
          return this.student.closedOrPreRegistrationStudents;
      }
    },
    currentTotalStudents() {
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          return this.totalStudents;
        case this.TABS.TRIAL_ACCOUNT:
          return this.totalTrialStudents;
        default:
          return this.totalClosedOrPreRegistrationStudents;
      }
    },
    currentTotalStudentsWithLazyLoading() {
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          this.$logger.debug('Total number of normal students: ', this.totalStudents);
          return this.normalLazyLoadingDone ? this.totalStudents : '...';
        case this.TABS.TRIAL_ACCOUNT:
          this.$logger.debug('Total number of trial students: ', this.totalStudents);
          return this.trialLazyLoadingDone ? this.totalTrialStudents : '...';
        default:
          this.$logger.debug('Total number of closed/pre-registered students: ', this.totalStudents);
          return this.closedOrPreRegistrationLazyLoadingDone ? this.totalClosedOrPreRegistrationStudents : '...';
      }
    },
    selectedFieldLabels() {
      const filteredFields = this.fields.filter(
        (field) =>
          field.enable == true &&
          field.label &&
          field.key != 'remainingDaysToDelete' &&
          field.key != 'trialExpirationDatetime'
      );
      return filteredFields.map((field) => field.label);
    },
    ...mapState(['student']),
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapState(['school']),
    ...mapState(['teacher']),
    ...mapState(['student_importer']),
    ...mapState({
      teachingMaterials: (state) => state.teaching_material.teachingMaterials,
    }),
    ...mapState(['product']),
    ...mapGetters('student', [
      'totalStudents',
      'totalTrialStudents',
      'totalClosedOrPreRegistrationStudents',
      'getExcelFormattedStudents',
    ]),
    ...mapGetters('teaching_material', ['getTeachingMaterialNamesByCodes']),
    ...mapGetters('role', [
      'hasAdminPrivilege',
      'hasTeacherPrivilege',
      'hasCorporationPrivilege',
      'hasBrandPrivilege',
      'hasSchoolPrivilege',
    ]),
  },
  methods: {
    searchIcon() {
      return require('@/assets/images/search-icon.png');
    },
    async searchByField() {
      this.appliedFilterBy = {};

      if (this.selectedCorporation) this.appliedFilterBy.corporationId = this.selectedCorporation;
      if (this.selectedBrand) this.appliedFilterBy.brandId = this.selectedBrand;
      if (this.selectedSchool) this.appliedFilterBy.schoolId = this.selectedSchool;
      if (this.selectedSearchColumn && this.selectedFilterValue) {
        this.appliedFilterBy[this.selectedSearchColumn] = this.selectedFilterValue;
      } else {
        this.selectedSearchColumn = this.DEFAULT_SEARCH_COLUMN;
        this.selectedFilterValue = null;
      }
      this.$logger.debug('Excecuted Search with parameters: ', this.appliedFilterBy);

      this.goToFirstPage();
      await this.loadNewData();
    },
    async orderByField() {
      this.appliedOrderBy = {};

      if (this.selectedOrderColumn) {
        this.appliedOrderBy['orderBy'] = this.selectedOrderColumn;
        this.appliedOrderBy['orderDir'] = this.selectedOrderDirection;
      }
      this.$logger.debug('Excecute Order / Sort with parameters: ', this.appliedOrderBy);

      this.goToFirstPage();
      await this.loadNewData();
    },
    displayAppliedFilterIfAny() {
      // Initialize
      this.selectedSearchColumn = this.DEFAULT_SEARCH_COLUMN;
      this.selectedFilterValue = null;
      this.selectedCorporation = null;
      this.selectedBrand = null;
      this.selectedSchool = null;

      // Show applied filters on the screen
      if (this.appliedFilterBy) {
        this.$logger.debug('Filter condition is applied and will be reflected to the screen.');
        this.searchOptions.forEach((item) => {
          if (this.appliedFilterBy[item.value]) {
            this.selectedSearchColumn = item.value;
            this.selectedFilterValue = this.appliedFilterBy[item.value];
          }
        });

        if (this.appliedFilterBy.corporationId) {
          this.selectedCorporation = this.appliedFilterBy.corporationId;
          this.pickedCorporation();
        }
        if (this.appliedFilterBy.brandId) {
          this.selectedBrand = this.appliedFilterBy.brandId;
          this.pickedBrand();
        }
        if (this.appliedFilterBy.schoolId) this.selectedSchool = this.appliedFilterBy.schoolId;
      }
    },
    displayAppliedOrderIfAny() {
      // Initialize
      this.selectedOrderColumn = null;
      this.selectedOrderDirection = this.DEFAULT_SORT_DIRECTION; // Asc

      if (this.appliedOrderBy) {
        this.$logger.debug('Order condition is applied and will be reflceted to the screen.');
        if (this.appliedOrderBy.orderBy) this.selectedOrderColumn = this.appliedOrderBy.orderBy;
        if (this.appliedOrderBy.orderDir) this.selectedOrderDirection = this.appliedOrderBy.orderDir;
      }
    },
    unsetFilterValue() {
      this.selectedFilterValue = '';
    },
    unsetSearchAndSortConditions() {
      this.selectedCorporation = null;
      this.selectedBrand = null;
      this.selectedSchool = null;
      this.selectedSearchColumn = this.DEFAULT_SEARCH_COLUMN;
      this.selectedFilterValue = null;
      this.selectedOrderColumn = '';
      this.selectedOrderDirection = this.DEFAULT_SORT_DIRECTION;
      this.appliedFilterBy = null;
      this.appliedOrderBy = null;
    },
    async initSearchAndSortFeature() {
      this.setSortOptions();
      this.setSearchOptions();
      this.setRadioOptions();
      this.setNextTeachingMaterialDates();

      if (this.hasAdminPrivilege) {
        await this.fetchCorporations();
      } else {
        // If Role of user is Corporation or Brand, set the Corporation/Brand ID
        this.setCorporationAndBrand();
      }
    },
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateTableHeight();
      updateStickyColumnsAndMinWidth({ leftColumns: 1, rightColumns: 1 });
    },
    async perPageChanged() {
      // this.offset = oldPerPage * (this.currentPage - 1);
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          this.perStudentPage = this.perPage;
          await this.loadNewData();
          break;
        case this.TABS.TRIAL_ACCOUNT:
          this.perTrialStudentPage = this.perPage;
          await this.loadNewData();
          break;
        case this.TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT:
        default:
          this.perClosedOrPreRegistrationStudentPage = this.perPage;
          await this.loadNewData();
          break;
      }
    },
    selectTab(tab) {
      this.$logger.debug('Select Tab:' + tab);
      this.currentTab = tab;
      this.selectedFunction = null;
      this.unsetSearchAndSortConditions();

      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          this.perPage = this.perStudentPage;
          this.currentPage = this.currentStudentPage;
          this.goToFirstPage();
          this.initNomalAccountTab();
          break;
        case this.TABS.TRIAL_ACCOUNT:
          this.perPage = this.perTrialStudentPage;
          this.currentPage = this.currentTrialStudentPage;
          this.goToFirstPage();
          this.initTrialAccountTab();
          break;
        case this.TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT:
        default:
          this.perPage = this.perClosedOrPreRegistrationStudentPage;
          this.currentPage = this.currentCloseOrPreRegistrationStudentPage;
          this.goToFirstPage();
          this.initTemporaryAccountTab();
          break;
      }
      this.loadNewData();

      // If Role of user is Corporation or Brand, set the Corporation/Brand ID
      this.setCorporationAndBrand();
    },
    initNomalAccountTab() {
      this.setFieldsOfNomalAccountTab();
      this.setBatchFunctionsOfNomalAccountTab();
    },
    initTrialAccountTab() {
      this.setFieldsOfTrialAccountTab();
      this.setBatchFunctionsOfTrialAccountTab();
    },
    initTemporaryAccountTab() {
      this.setFieldsOfTemporaryAccountTab();
      this.setBatchFunctionsOfTemporaryAccountTab();
    },
    loadNormalStudents({
      limit = null,
      offset = 0,
      setBusy = false,
      filterBy = null,
      orderBy = null,
      orderDir = null,
    }) {
      let params = {
        type: 'normal_account',
        limit: limit,
        offset: offset,
      };
      if (limit) params.limit = limit;
      if (setBusy) this.normalBusy = true;
      if (filterBy) params.filterBy = filterBy;
      if (orderBy) params.orderBy = orderBy;
      if (orderBy) params.orderDir = orderDir;

      return new Promise((resolve) => {
        this.fetchStudents(params)
          .then(() => {
            this.normalBusy = false;
            this.$logger.debug('Current Normal Students', this.student.students);
            resolve();
          })
          .catch(() => {
            this.$logger.debug('Error in fetchStudents');
          });
      });
    },
    loadTrialStudents({ limit = null, offset = 0, setBusy = false, filterBy = null, orderBy = null, orderDir = null }) {
      let params = {
        type: 'trial_account',
        limit: limit,
        offset: offset,
      };
      if (limit) params.limit = limit;
      if (setBusy) this.trialBusy = true;
      if (filterBy) params.filterBy = filterBy;
      if (orderBy) params.orderBy = orderBy;
      if (orderBy) params.orderDir = orderDir;

      return new Promise((resolve) => {
        this.fetchTrialStudents(params)
          .then(() => {
            this.trialBusy = false;
            this.$logger.debug('Current Trial Students', this.student.trialStudents);
            resolve();
          })
          .catch(() => {
            this.$logger.debug('Error in fetchTrialStudents');
          });
      });
    },
    loadClosedOrPreRegistrationStudents({
      limit = null,
      offset = 0,
      setBusy = false,
      filterBy = null,
      orderBy = null,
      orderDir = null,
    }) {
      let params = {
        type: 'closed_or_pre_registration_account',
        limit: limit,
        offset: offset,
      };
      if (limit) params.limit = limit;
      if (setBusy) this.closedOrPreRegistrationBusy = true;
      if (filterBy) params.filterBy = filterBy;
      if (orderBy) params.orderBy = orderBy;
      if (orderBy) params.orderDir = orderDir;

      return new Promise((resolve) => {
        this.fetchClosedOrPreRegistrationStudents(params)
          .then(() => {
            this.closedOrPreRegistrationBusy = false;
            this.$logger.debug('Current Closed Or Pre Reg Students', this.student.closedOrPreRegistrationStudents);
            resolve();
          })
          .catch(() => {
            this.$logger.debug('Error in fetchClosedOrPreRegistrationStudents');
          });
      });
    },
    setFieldsOfNomalAccountTab() {
      this.$logger.debug('Set fields of ' + this.currentTab + ' tab');
      this.fields = [
        {
          key: 'selected',
          sortable: false,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column left-sticky-column-1',
          thAttr: { width: 20 },
        },
        {
          key: 'corporation',
          label: '法人名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'brand',
          label: 'ブランド名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'school',
          label: '教場名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'course',
          label: 'コース名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'tamaiClass',
          label: 'クラス名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'mainTeacher',
          label: '先生名（担当・メイン）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'uid',
          label: '生徒ID',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'nameKana',
          label: '生徒名フリガナ',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'figuredShapeTeachingMaterial',
          label: '教材（極 - 図形）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredShapeTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredAlgebraTeachingMaterial',
          label: '教材（極 - 数）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredAlgebraTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredJapaneseTeachingMaterial',
          label: '教材（国語）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredJapaneseTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredKidsMathematicsTeachingMaterial',
          label: '教材（遊）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredKidsMathematicsTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredAdvancedMathematicsTeachingMaterial',
          label: '教材（悟）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredAdvancedMathematicsTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'nextFiguredTeachingMaterialMonth',
          label: '教材変更 – 変更適用月',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'nextFiguredShapeTeachingMaterial',
          label: '教材変更 – 変更後教材（極 - 図形）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredShapeTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredAlgebraTeachingMaterial',
          label: '教材変更 – 変更後教材（極 - 数）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredAlgebraTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredJapaneseTeachingMaterial',
          label: '教材変更 – 変更後教材（国語）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredJapaneseTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredKidsMathematicsTeachingMaterial',
          label: '教材変更 – 変更後教材（遊）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredKidsMathematicsTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredAdvancedMathematicsTeachingMaterial',
          label: '教材変更 – 変更後教材（悟）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return this.figuredAdvancedMathematicsTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'preRegistrationDateStatus',
          label: '利用開始月予約',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'deactivatedDatetime',
          label: '休会開始月',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'updatedAt',
          label: '編集日時',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return basicDatetime(item.updatedAt);
          },
        },
      ];
      if (this.hasTeacherPrivilege) {
        this.fields.push({
          key: 'learningHistory',
          label: '学習履歴',
          sortable: false,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column right-sticky-column-1 history-colmun',
        });
      }
    },
    setFieldsOfTrialAccountTab() {
      this.$logger.debug('Set fields of ' + this.currentTab + ' tab');
      this.fields = [
        {
          key: 'selected',
          sortable: false,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column left-sticky-column-1',
          thAttr: { width: 20 },
        },
        {
          key: 'corporation',
          label: '法人名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'brand',
          label: 'ブランド名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'school',
          label: '教場名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'course',
          label: 'コース名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'tamaiClass',
          label: 'クラス名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'mainTeacher',
          label: '先生名（担当・メイン）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'uid',
          label: '体験ID',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'studentNameId',
          label: '体験ID名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return basicTrialStudentNameIdPresent(item);
          },
        },
        {
          key: 'trialCourseCode',
          label: '体験コード',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (_v1, _v2, item) => {
            return basicPresent(item.trialCourseCode);
          },
        },
        {
          key: 'nameKana',
          label: '生徒名フリガナ',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'figuredShapeTeachingMaterial',
          label: '教材（極 - 図形）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredShapeTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredAlgebraTeachingMaterial',
          label: '教材（極 - 数）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredAlgebraTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredJapaneseTeachingMaterial',
          label: '教材（国語）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredJapaneseTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredKidsMathematicsTeachingMaterial',
          label: '教材（遊）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredKidsMathematicsTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredAdvancedMathematicsTeachingMaterial',
          label: '教材（悟）',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredAdvancedMathematicsTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'trialExpirationDatetime',
          label: '有効期限',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'updatedAt',
          label: '編集日時',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return basicDatetime(item.updatedAt);
          },
        },
        {
          key: 'preRegistrationDateStatus',
          label: '利用開始月予約',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
      ];
    },
    setFieldsOfTemporaryAccountTab() {
      this.$logger.debug('Set fields of ' + this.currentTab + ' tab');
      this.fields = [
        {
          key: 'selected',
          sortable: false,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column left-sticky-column-1',
          thAttr: { width: 20 },
        },
        {
          key: 'preRegistrationStatus',
          label: 'ステータス',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'statusUpdateDate',
          label: 'ステータス更新日',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'corporation',
          label: '法人名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'brand',
          label: 'ブランド名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'school',
          label: '教場名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'course',
          label: 'コース名',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'tamaiClass',
          label: 'クラス名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'mainTeacher',
          label: '先生名（担当・メイン）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'uid',
          label: '生徒ID',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'nameKana',
          label: '生徒名フリガナ',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'figuredShapeTeachingMaterial',
          label: '教材（極 - 図形）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredShapeTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredAlgebraTeachingMaterial',
          label: '教材（極 - 数）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredAlgebraTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredJapaneseTeachingMaterial',
          label: '教材（国語）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredJapaneseTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredKidsMathematicsTeachingMaterial',
          label: '教材（遊）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredKidsMathematicsTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'figuredAdvancedMathematicsTeachingMaterial',
          label: '教材（悟）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return this.figuredAdvancedMathematicsTeachingMaterialDisplay(item.currentLevelMaterials);
          },
        },
        {
          key: 'nextFiguredTeachingMaterialMonth',
          label: '教材変更 – 変更適用月',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'nextFiguredShapeTeachingMaterial',
          label: '教材変更 – 変更後教材（極 - 図形）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          formatter: (_v1, _v2, item) => {
            return this.figuredShapeTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredAlgebraTeachingMaterial',
          label: '教材変更 – 変更後教材（極 - 数）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          formatter: (_v1, _v2, item) => {
            return this.figuredAlgebraTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredJapaneseTeachingMaterial',
          label: '教材変更 – 変更後教材（国語）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          formatter: (_v1, _v2, item) => {
            return this.figuredJapaneseTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredKidsMathematicsTeachingMaterial',
          label: '教材変更 – 変更後教材（遊）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          formatter: (_v1, _v2, item) => {
            return this.figuredKidsMathematicsTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'nextFiguredAdvancedMathematicsTeachingMaterial',
          label: '教材変更 – 変更後教材（悟）',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 200 },
          formatter: (_v1, _v2, item) => {
            return this.figuredAdvancedMathematicsTeachingMaterialDisplay(item.nextLevelMaterials);
          },
        },
        {
          key: 'preRegistrationDateStatus',
          label: '利用開始月予約',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'deactivatedDatetime',
          label: '休会開始月',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'remainingDaysToDelete',
          label: '削除カウント',
          sortable: false,
          hidable: true,
          enable: true,
          searchable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'updatedAt',
          label: '編集日時',
          sortable: false,
          hidable: true,
          enable: false,
          searchable: true,
          thAttr: { width: 150 },
          formatter: (_v1, _v2, item) => {
            return basicDatetime(item.updatedAt);
          },
        },
      ];
    },
    setBatchFunctionsOfNomalAccountTab() {
      this.$logger.debug('Set batch functions of ' + this.currentTab + ' tab');
      this.batchFunctions = [];
      if (!this.hasTeacherPrivilege) {
        this.batchFunctions.push({
          value: 'changeStudentAffiliation',
          label: '生徒所属変更',
        });
      }
      this.batchFunctions.push(
        {
          value: 'pdfOutputPopup',
          label: '生徒用お知らせPDF出力',
        },
        {
          value: 'deactivatePopup',
          label: '休会予約',
        },
        {
          value: 'reactivatePopup',
          label: '休会予約キャンセル',
        },
        {
          value: 'upgradeLevel1Popup',
          label: '進級（図形の極）',
        },
        {
          value: 'upgradeLevel31Popup',
          label: '進級（中学生の図形の極 – 平面）',
        },
        {
          value: 'upgradeLevel32Popup',
          label: '進級（中学生の図形の極 – 空間）',
        },
        {
          value: 'upgradeLevel3Popup',
          label: '進級（中学生の図形の極 – Grade4以上）',
        },
        {
          value: 'upgradeLevel2Popup',
          label: '進級（数の極）',
        },
        {
          value: 'upgradeLevel4Popup',
          label: '進級（中学生の代数の極）',
        },
        {
          value: 'upgradeLevel7Popup',
          label: '進級（魔法の国語）',
        },
        {
          value: 'upgradeLevel6Popup',
          label: '進級（遊）',
        },
        {
          value: 'upgradeLevel5Popup',
          label: '進級（数学の悟）',
        }
      );
      if (this.hasAdminPrivilege) {
        this.batchFunctions.push({
          value: 'downgradeLevelPopup',
          label: '進級取消',
        });
      }
      this.batchFunctions.push(
        {
          value: 'changeNextFiguredTeachingMaterialPopup',
          label: '教材変更予約',
        },
        {
          value: 'clearNextFiguredTeachingMaterialPopup',
          label: '教材変更予約キャンセル',
        }
      );
    },
    setBatchFunctionsOfTrialAccountTab() {
      this.$logger.debug('Set batch functions of ' + this.currentTab + ' tab');
      this.batchFunctions = [
        {
          value: 'pdfOutputPopup',
          label: '生徒用お知らせPDF出力',
        },
      ];
    },
    setBatchFunctionsOfTemporaryAccountTab() {
      this.$logger.debug('Set batch functions of ' + this.currentTab + ' tab');
      this.batchFunctions = [];
      if (!this.hasTeacherPrivilege) {
        this.batchFunctions.push({
          value: 'changeStudentAffiliation',
          label: '生徒所属変更',
        });
      }
      this.batchFunctions.push(
        {
          value: 'pdfOutputPopup',
          label: '生徒用お知らせPDF出力',
        },
        {
          value: 'changePreRegistrationTimePopup',
          label: '利用開始予約',
        },
        {
          value: 'clearPreRegistrationTimePopup',
          label: '利用開始予約キャンセル',
        },
        {
          value: 'upgradeLevel1Popup',
          label: '進級（図形の極）',
        },
        {
          value: 'upgradeLevel31Popup',
          label: '進級（中学生の図形の極 – 平面）',
        },
        {
          value: 'upgradeLevel32Popup',
          label: '進級（中学生の図形の極 – 空間）',
        },
        {
          value: 'upgradeLevel3Popup',
          label: '進級（中学生の図形の極 – Grade4以上）',
        },
        {
          value: 'upgradeLevel2Popup',
          label: '進級（数の極）',
        },
        {
          value: 'upgradeLevel4Popup',
          label: '進級（中学生の代数の極）',
        },
        {
          value: 'upgradeLevel7Popup',
          label: '進級（魔法の国語）',
        },
        {
          value: 'upgradeLevel6Popup',
          label: '進級（遊）',
        },
        {
          value: 'upgradeLevel5Popup',
          label: '進級（数学の悟）',
        }
      );
      if (this.hasAdminPrivilege) {
        this.batchFunctions.push({
          value: 'downgradeLevelPopup',
          label: '進級取消',
        });
      }
      this.batchFunctions.push({
        value: 'changeFiguredTeachingMaterialPopup',
        label: '教材変更',
      });
    },
    setSortOptions() {
      this.$logger.debug('Set sort options of ' + this.currentTab + ' tab');
      this.sortOptions = [
        {
          value: 'uid',
          label: '生徒ID',
        },
        {
          value: 'nameKana',
          label: '生徒フリガナ',
        },
        {
          value: 'updatedAt',
          label: '編集日時',
        },
        {
          value: 'deactivatedDatetime',
          label: '休会開始月',
        },
        {
          value: 'preRegistrationDatetime',
          label: '利用開始月予約',
        },
      ];
    },
    setSearchOptions() {
      this.$logger.debug('Set search options of ' + this.currentTab + ' tab');
      this.searchOptions = [
        {
          value: '検索項目を選択',
          label: '検索項目を選択',
        },
        {
          value: 'courseName',
          label: 'コース名',
        },
        {
          value: 'teacherName',
          label: '先生名',
        },
        {
          value: 'uid',
          label: '生徒ID',
        },
        {
          value: 'name',
          label: '生徒名',
        },
        {
          value: 'nameKana',
          label: '生徒フリガナ',
        },
        {
          value: 'hasNextTeachingMaterial',
          label: '教材変更 – 変更適用月',
        },
      ];
      this.selectedSearchColumn = this.DEFAULT_SEARCH_COLUMN;
    },
    setRadioOptions() {
      this.$logger.debug('Set radio options of ' + this.currentTab + ' tab');
      this.radioOptions = [
        { item: 'ASC', name: '昇順' },
        { item: 'DESC', name: '降順' },
      ];
    },
    setNextTeachingMaterialDates() {
      this.nextTeachingMaterialDates = [];
      this.nextTeachingMaterialDates.push(nextMonthJP());
    },
    setCorporationAndBrand() {
      // If have access for Searching by brand (it means they have chosen Corporation already)
      if (this.hasCorporationPrivilege) {
        this.$logger.debug('Set default value of selectedCorporation to be ', this.corporation.corporation.id);
        this.selectedCorporation = this.corporation.corporation.id;
        this.pickedCorporation();
      }

      // If have access for Searching by school (it means they have chosen Brand already)
      if (this.hasBrandPrivilege) {
        this.$logger.debug('Set default value of selectedBrand to be ', this.brand.brand.id);
        this.selectedBrand = this.brand.brand.id;
        this.pickedBrand();
      }
    },
    notSelectedPopup() {
      this.$logger.debug('Display not selected Error');
      this.$refs['not_selected'].show();
    },
    pdfOutputPopup() {
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    deactivatePopup() {
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'deactivatedDatetime',
          label: '処理前の休会開始月',
          sortable: true,
          thAttr: { width: 150 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    reactivatePopup() {
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'deactivatedDatetime',
          label: '処理前の休会開始月',
          sortable: true,
          thAttr: { width: 150 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    upgradingLevelFields() {
      return [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'preLevelUpdate',
          label: '学習中',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'expectedLevelUpgrade',
          label: '進級後',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
    },
    downgradingLevelFields() {
      return [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'preLevelUpdate',
          label: '学習中',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'expectedLevelDowngrade',
          label: '進級取消後',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
    },
    filterSelectedForPostLevelUpdate() {
      this.noticeMsg = '';
      this.filteredSelected = [];
      let alreadyUpdatedStudentNames = [];
      let alreadyUpdatedStudentNamesInString = '';
      let postUpdateSelected = cloneDeep(this.selected);

      // Create a list of succesfully updated student to be shown on selected_result_function modal
      for (let i = 0; i < postUpdateSelected.length; i++) {
        if (this.preUpdateSelected.length > 0) {
          let postUpdateLevel = this.findUpdateLevel(postUpdateSelected[i].levels);
          let preUpdateLevel = this.findUpdateLevel(this.preUpdateSelected[i].levels);
          // If the level of preUpgrade and postUpgrade is different, it means the level was upgraded
          if (postUpdateLevel.name != preUpdateLevel.name) {
            this.filteredSelected.push(postUpdateSelected[i]);
          } else {
            alreadyUpdatedStudentNames.push(postUpdateSelected[i].name);
          }
        }
      }

      // Create a notice message to be shown on selected_result_function modal if there are students not updated
      if (alreadyUpdatedStudentNames.length > 0) {
        for (let i = 0; i < alreadyUpdatedStudentNames.length; i++) {
          alreadyUpdatedStudentNamesInString = alreadyUpdatedStudentNamesInString + alreadyUpdatedStudentNames[i];
          // add comma if there is a next student
          if (i + 1 < alreadyUpdatedStudentNames.length) {
            alreadyUpdatedStudentNamesInString += ', ';
          }
        }

        if (this.isUpgradingLevelPopup) {
          this.noticeMsg =
            alreadyUpdatedStudentNamesInString +
            'の進級処理が出来ませんでした。この生徒がすでに最終級に達しているか、または他の先生によってすでに進級された可能性があります。ページを再読込してご確認ください。';
        } else if (this.isDowngradeLevelPopup) {
          this.noticeMsg =
            alreadyUpdatedStudentNamesInString +
            'の進級取消処理が出来ませんでした。この生徒が最初の級を受講している、または他の先生によってすでに進級取消された可能性があります。ページを再読込してご確認ください。';
        }
      }
    },
    upgradeLevel1Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '図形の極');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel31Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '中学生の図形の極 – 平面');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel32Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '中学生の図形の極 – 空間');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel3Popup() {
      this.selectedMaterialLevel = this.materialLevels.find(
        (material) => material.name == '中学生の図形の極 – Grade4以上'
      );
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel2Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '数の極');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel4Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '中学生の代数の極');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel7Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '魔法の国語');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel6Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '遊');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    upgradeLevel5Popup() {
      this.selectedMaterialLevel = this.materialLevels.find((material) => material.name == '数学の悟');
      this.checkSelectedStudentsLevelUpgradingAllowed();
    },
    checkSelectedStudentsLevelUpgradingAllowed() {
      const students = this.selected;
      for (const student of students) {
        if (!this.checkLevelUpdatingAllowed(student)) {
          this.$refs['upgrade_level_error'].show();
          return;
        }
      }
      this.$logger.debug('Show upgrade level upgrading popup to confirm');
      this.showUpgradeLevelPopup();
    },
    checkLevelUpdatingAllowed(student) {
      let code = this.selectedMaterialLevel.materialCode;
      const level = find(student.levels, (level) => level.position == this.selectedMaterialLevel.levelPosition);

      // Special handling to block invalid promotion in TeachingMaterial 100
      if (this.isUpgradingLevelPopup) {
        switch (code) {
          case '100':
            // Example:  G2平面G3空間＝進級可  G3平面G3空間＝進級不可  G4＝進級不可
            if (isEmpty(level.subLevels) || !isEmpty(level.nextLevel)) return false;
            break;
          case '101':
            // Example:  G2平面G3空間＝進級不可  G3平面G3空間＝進級可  G4＝進級可
            if (!isEmpty(level.subLevels) && isEmpty(level.nextLevel)) return false;
            code = '100'; // code 101 is just a temporary code to know the upgrade is to Grade4 or higher. The following process doesn't handle 101, so set 100 to the code
            break;
        }
      } else if (this.isDowngradeLevelPopup) {
        switch (code) {
          case '100':
            // Example:  G2平面G3空間＝進級取消可  G3平面G3空間＝進級取消可  G4＝進級取消不可
            if (isEmpty(level.subLevels)) return false;
            break;
          case '101':
            // Example:  G2平面G3空間＝進級取消不可  G3平面G3空間＝進級取消不可  G4＝進級取消可
            if (!isEmpty(level.subLevels)) return false;
            code = '100'; // code 101 is just a temporary code to know the downgrade is to Grade4 or higher. The following process doesn't handle 101, so set 100 to the code
            break;
        }
      }
      return student.figuredTeachingMaterialCodes && student.figuredTeachingMaterialCodes.includes(code);
    },
    showUpgradeLevelPopup() {
      this.selectedFunctionFields = this.upgradingLevelFields();
      this.$refs['selected_function'].show();
    },
    selectDowngradeLevelConfirmed() {
      if (!this.selectedMaterialLevel) {
        this.$refs['downgrade_level_select_error'].show();
      } else {
        const students = this.selected;
        for (const student of students) {
          if (!this.checkLevelUpdatingAllowed(student)) {
            this.$refs['downgrade_level_error'].show();
            return;
          }
        }
        this.$logger.debug('Show downgrade level downgrading popup to confirm');
        this.showDowngradeLevelPopup();
      }
    },
    selectDowngradeLevelPopup() {
      this.selectedMaterialLevel = null;
      this.$refs['select_downgrade_level'].show();
    },
    showDowngradeLevelPopup() {
      this.selectedFunctionFields = this.downgradingLevelFields();
      this.$refs['selected_function'].show();
    },
    changeNextFiguredTeachingMaterialPopup() {
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'figuredShapeTeachingMaterial',
          label: '学習中の教材（極 - 図形）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredAlgebraTeachingMaterial',
          label: '学習中の教材（極 - 数）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredJapaneseTeachingMaterial',
          label: '学習中の教材（国語）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredKidsMathematicsTeachingMaterial',
          label: '学習中の教材（遊）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredAdvancedMathematicsTeachingMaterial',
          label: '学習中の教材（悟）',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    clearNextFiguredTeachingMaterialPopup() {
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'figuredShapeTeachingMaterial',
          label: '学習中の教材（極 - 図形）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredAlgebraTeachingMaterial',
          label: '学習中の教材（極 - 数）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredJapaneseTeachingMaterial',
          label: '学習中の教材（国語）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredKidsMathematicsTeachingMaterial',
          label: '学習中の教材（遊）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredAdvancedMathematicsTeachingMaterial',
          label: '学習中の教材（悟）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'nextFiguredShapeTeachingMaterial',
          label: '変更予定の教材（極 - 図形）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'nextFiguredAlgebraTeachingMaterial',
          label: '変更予定の教材（極 - 数）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'nextFiguredJapaneseTeachingMaterial',
          label: '変更予定の教材（国語）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'nextFiguredKidsMathematicsTeachingMaterial',
          label: '変更予定の教材（遊）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'nextFiguredAdvancedMathematicsTeachingMaterial',
          label: '変更予定の教材（悟）',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    changePreRegistrationTimePopup() {
      this.$logger.debug('Display Reservation to start use Popup');
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'preRegistrationStatus',
          label: '処理前のステータス',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    clearPreRegistrationTimePopup() {
      this.$logger.debug('Display Cancellation of use start reservation Popup');
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'preRegistrationStatus',
          label: '処理前のステータス',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    changeFiguredTeachingMaterialPopup() {
      this.$logger.debug('Display Change teaching material Popup');
      this.selectedFunctionFields = [
        {
          key: 'uid',
          label: '生徒ID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: '生徒名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'figuredShapeTeachingMaterial',
          label: '現在の教材（極 - 図形）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredAlgebraTeachingMaterial',
          label: '現在の教材（極 - 数）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredJapaneseTeachingMaterial',
          label: '現在の教材（国語）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredKidsMathematicsTeachingMaterial',
          label: '現在の教材（遊）',
          sortable: true,
          thAttr: { width: 200 },
        },
        {
          key: 'figuredAdvancedMathematicsTeachingMaterial',
          label: '現在の教材（悟）',
          sortable: true,
          thAttr: { width: 200 },
        },
      ];
      this.$refs['selected_function'].show();
    },
    executeBatchFunction() {
      if (this.selectedStudentSize > 0) {
        switch (this.selectedFunction) {
          case 'changeStudentAffiliation':
            this.$logger.debug('Redirect to Change student affiliation page');
            this.storeSelectedStudents(this.selected);
            this.$router.push({ name: 'student-change-affiliation' });
            break;
          case 'pdfOutputPopup':
            this.$logger.debug('Show PDF popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.pdfOutputPopup();
            break;
          case 'deactivatePopup':
            this.$logger.debug('Show deactivate popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.deactivatePopup();
            break;
          case 'reactivatePopup':
            this.$logger.debug('Show reactivate popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.reactivatePopup();
            break;
          case 'upgradeLevel1Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel1Popup();
            break;
          case 'upgradeLevel31Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel31Popup();
            break;
          case 'upgradeLevel32Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel32Popup();
            break;
          case 'upgradeLevel3Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel3Popup();
            break;
          case 'upgradeLevel2Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel2Popup();
            break;
          case 'upgradeLevel4Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel4Popup();
            break;
          case 'upgradeLevel7Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel7Popup();
            break;
          case 'upgradeLevel6Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel6Popup();
            break;
          case 'upgradeLevel5Popup':
            this.storeSelectedStudents(this.selected);
            this.upgradeLevel5Popup();
            break;
          case 'downgradeLevelPopup':
            this.storeSelectedStudents(this.selected);
            this.selectDowngradeLevelPopup();
            break;
          case 'changeNextFiguredTeachingMaterialPopup':
            this.$logger.debug('Show change next figured teaching material popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.changeNextFiguredTeachingMaterialPopup();
            break;
          case 'clearNextFiguredTeachingMaterialPopup':
            this.$logger.debug('Show revert changing figured teaching material popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.clearNextFiguredTeachingMaterialPopup();
            break;
          case 'changePreRegistrationTimePopup':
            this.$logger.debug('Show change pre registration time popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.changePreRegistrationTimePopup();
            break;
          case 'clearPreRegistrationTimePopup':
            this.$logger.debug('Show clear pre registration time popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.clearPreRegistrationTimePopup();
            break;
          case 'changeFiguredTeachingMaterialPopup':
            this.$logger.debug('Show change figured teaching material popup to confirm');
            this.storeSelectedStudents(this.selected);
            this.changeFiguredTeachingMaterialPopup();
            break;
        }
      } else {
        this.notSelectedPopup();
      }
    },
    selectedFunctionConfirmed() {
      if (this.selectedStudentSize > 0) {
        switch (this.selectedFunction) {
          case 'pdfOutputPopup':
            this.$logger.debug('Export selected Students to PDF');
            this.resetPasswordAndExportPdf();
            break;
          case 'deactivatePopup':
            if (this.deactivateMonth) {
              if (secondsDiff(currentDayJP().value, this.deactivateMonth) > 0) {
                this.deactivateStudents(this.deactivateMonth).then(() => {
                  this.$logger.debug('Show deactivate result popup to review');
                  last(this.selectedFunctionFields)['label'] = '休会開始月';
                  this.$refs['selected_result_function'].show();
                });
              } else {
                this.$refs['deactivate_error'].show();
              }
            } else {
              this.$refs['deactivate_select_error'].show();
            }
            break;
          case 'reactivatePopup':
            this.reactivateStudents().then(() => {
              this.$logger.debug('Show reactivate result popup to review');
              last(this.selectedFunctionFields)['label'] = '休会開始月';
              this.$refs['selected_result_function'].show();
            });
            break;
          case 'upgradeLevel1Popup':
          case 'upgradeLevel31Popup':
          case 'upgradeLevel32Popup':
          case 'upgradeLevel3Popup':
          case 'upgradeLevel2Popup':
          case 'upgradeLevel4Popup':
          case 'upgradeLevel7Popup':
          case 'upgradeLevel6Popup':
          case 'upgradeLevel5Popup':
            this.preUpdateSelected = cloneDeep(this.selected);
            this.upgradeLevelStudents(this.selectedMaterialLevel.level).then(() => {
              this.$logger.debug(`Show ${this.selectedMaterialLevel.level} upgrade result popup to review`);
              this.displayPostLevelUpgradePopup();
            });
            break;
          case 'downgradeLevelPopup':
            this.preUpdateSelected = cloneDeep(this.selected);
            this.downgradeLevelStudents(this.selectedMaterialLevel.level).then(() => {
              this.$logger.debug(`Show ${this.selectedMaterialLevel.level} downgrade result popup to review`);
              this.displayPostLevelDowngradePopup();
            });
            break;
          case 'changeNextFiguredTeachingMaterialPopup':
            if (this.nextTeachingMaterialCodes.length > 0) {
              if (this.isImmediate) {
                this.$refs['comfirmisImmediate'].show();
                break;
              } else {
                this.upgradeNextFiguredTeachingMaterial(this.nextTeachingMaterialCodes).then(() => {
                  this.$logger.debug('Show changing next teaching material from next month popup to review');
                  this.selectedFunctionFields.push(
                    {
                      key: 'nextFiguredShapeTeachingMaterial',
                      label: '変更予定の教材（極 - 図形）',
                      sortable: true,
                      thAttr: { width: 200 },
                    },
                    {
                      key: 'nextFiguredAlgebraTeachingMaterial',
                      label: '変更予定の教材（極 - 数）',
                      sortable: true,
                      thAttr: { width: 200 },
                    },
                    {
                      key: 'nextFiguredJapaneseTeachingMaterial',
                      label: '変更予定の教材（国語）',
                      sortable: true,
                      thAttr: { width: 200 },
                    },
                    {
                      key: 'nextFiguredKidsMathematicsTeachingMaterial',
                      label: '変更予定の教材（遊）',
                      sortable: true,
                      thAttr: { width: 200 },
                    },
                    {
                      key: 'nextFiguredAdvancedMathematicsTeachingMaterial',
                      label: '変更予定の教材（悟）',
                      sortable: true,
                      thAttr: { width: 200 },
                    }
                  );
                  this.$refs['selected_result_function'].show();
                });
              }
            } else {
              this.$refs['change_next_figured_teaching_material_error'].show();
            }
            break;
          case 'clearNextFiguredTeachingMaterialPopup':
            this.clearNextFiguredTeachingMaterial().then(() => {
              this.$logger.debug('Show clear next teaching material from next month popup to review');
              this.selectedFunctionFields.pop(); // next AdvancedMathematics
              this.selectedFunctionFields.pop(); // next KidsMathematics
              this.selectedFunctionFields.pop(); // next Japanese
              this.selectedFunctionFields.pop(); // next Algebra
              this.selectedFunctionFields.pop(); // next Shape
              this.$refs['selected_result_function'].show();
            });
            break;
          case 'changePreRegistrationTimePopup':
            this.changePreRegistrationTime(this.preRegistrationMonth).then(() => {
              this.$logger.debug('Show changing pre registration month popup to review');
              this.displayNextPreRegistrationPopup();
            });
            break;
          case 'clearPreRegistrationTimePopup':
            this.clearPreRegistrationTime().then(() => {
              this.$logger.debug('Show clear pre registration month popup to review');
              this.displayNextPreRegistrationPopup();
            });
            break;
          case 'changeFiguredTeachingMaterialPopup':
            if (this.nextTeachingMaterialCodes.length > 0) {
              this.upgradeFiguredTeachingMaterial(this.nextTeachingMaterialCodes).then(() => {
                this.$logger.debug('Show changing teaching material from next month popup to review');
                this.selectedFunctionFields.pop(); // previous AdvancedMathematics
                this.selectedFunctionFields.pop(); // previous KidsMathematics
                this.selectedFunctionFields.pop(); // previous Japanese
                this.selectedFunctionFields.pop(); // previous Algebra
                this.selectedFunctionFields.pop(); // previous Shape
                this.selectedFunctionFields.push(
                  {
                    key: 'previousFiguredShapeTeachingMaterial',
                    label: '以前の教材（極 - 図形）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'previousFiguredAlgebraTeachingMaterial',
                    label: '以前の教材（極 - 数）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'previousFiguredJapaneseTeachingMaterial',
                    label: '以前の教材（国語）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'previousFiguredKidsMathematicsTeachingMaterial',
                    label: '以前の教材（遊）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'previousFiguredAdvancedMathematicsTeachingMaterial',
                    label: '以前の教材（悟）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'figuredShapeTeachingMaterial',
                    label: '変更後の教材（極 - 図形）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'figuredAlgebraTeachingMaterial',
                    label: '変更後の教材（極 - 数）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'figuredJapaneseTeachingMaterial',
                    label: '変更後の教材（国語）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'figuredKidsMathematicsTeachingMaterial',
                    label: '変更後の教材（遊）',
                    sortable: true,
                    thAttr: { width: 200 },
                  },
                  {
                    key: 'figuredAdvancedMathematicsTeachingMaterial',
                    label: '変更後の教材（悟）',
                    sortable: true,
                    thAttr: { width: 200 },
                  }
                );
                this.$refs['selected_result_function'].show();
              });
            } else {
              this.$refs['change_next_figured_teaching_material_error'].show();
            }
            break;
          default:
            break;
        }
      }
    },
    selectedFunctionRejected() {
      switch (this.selectedFunction) {
        case 'downgradeLevelPopup':
          this.$refs['select_downgrade_level'].show();
          return;
      }
      this.isImmediate = false;
      this.nextTeachingMaterialCodes = [];
      this.$logger.debug('PDF Output Popup cancelled');
    },
    downgradeLevelFunctionRejected() {
      this.$logger.debug('Downgrade Level Popup cancelled');
    },
    confirmisImmediate() {
      this.upgradeImmediateNextFiguredTeachingMaterial(this.nextTeachingMaterialCodes).then(() => {
        this.$logger.debug('Show changing immidiate next teaching material from next month popup to review');
        this.selectedFunctionFields.pop(); // previous AdvancedMathematics
        this.selectedFunctionFields.pop(); // previous KidsMathematics
        this.selectedFunctionFields.pop(); // previous Japanese
        this.selectedFunctionFields.pop(); // previous Algebra
        this.selectedFunctionFields.pop(); // previous Shape
        this.selectedFunctionFields.push(
          {
            key: 'previousFiguredShapeTeachingMaterial',
            label: '以前の教材（極 - 図形）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'previousFiguredAlgebraTeachingMaterial',
            label: '以前の教材（極 - 数）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'previousFiguredJapaneseTeachingMaterial',
            label: '以前の教材（国語）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'previousFiguredKidsMathematicsTeachingMaterial',
            label: '以前の教材（遊）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'previousFiguredAdvancedMathematicsTeachingMaterial',
            label: '以前の教材（悟）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'figuredShapeTeachingMaterial',
            label: '変更後の教材（極 - 図形）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'figuredAlgebraTeachingMaterial',
            label: '変更後の教材（極 - 数）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'figuredJapaneseTeachingMaterial',
            label: '変更後の教材（国語）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'figuredKidsMathematicsTeachingMaterial',
            label: '変更後の教材（遊）',
            sortable: true,
            thAttr: { width: 200 },
          },
          {
            key: 'figuredAdvancedMathematicsTeachingMaterial',
            label: '変更後の教材（悟）',
            sortable: true,
            thAttr: { width: 200 },
          }
        );
        this.$refs['selected_result_function'].show();
      });
    },
    resultFunctionConfirmed() {
      this.noticeMsg = '';
      this.isImmediate = false;
      this.nextTeachingMaterialCodes = [];
      this.$logger.debug('Result Popup confirmed');
      this.$refs['student-table'].refresh();
    },
    displayPostLevelUpgradePopup() {
      this.selectedFunctionFields.pop();
      const postField = last(this.selectedFunctionFields);
      postField['key'] = 'postLevelUpdate';
      postField['label'] = '進級後';
      this.filterSelectedForPostLevelUpdate();
      this.$refs['selected_result_function'].show();
    },
    displayPostLevelDowngradePopup() {
      this.selectedFunctionFields.pop();
      const postField = last(this.selectedFunctionFields);
      postField['key'] = 'postLevelUpdate';
      postField['label'] = '進級取消後';
      this.filterSelectedForPostLevelUpdate();
      this.$refs['selected_result_function'].show();
    },
    displayNextPreRegistrationPopup() {
      const postField = last(this.selectedFunctionFields);
      postField['key'] = 'nextPreRegistrationStatus';
      postField['label'] = '利用開始月予約';
      this.$refs['selected_result_function'].show();
    },
    displayColumns() {
      this.$logger.debug('Display Columns for Students');
      this.$refs['popup_holder'].show();
    },
    createNewStudent() {
      this.$router.push({ name: 'student-add' });
    },
    contentLoaded(fileContent) {
      const dataRows = csvParser(fileContent);
      const mappingKeys = this.student_importer.csvHeaderMapping;
      const requiredKeys = this.student_importer.csvRequiredHeaders;
      this.csvHashContent = [];
      this.inValidImportStudentList = [];
      for (const dataRow of dataRows) {
        const formattedData = keyConvert(mappingKeys, requiredKeys, dataRow, true);
        if (formattedData) {
          if (!this.checkValidPassword(formattedData.password)) {
            this.inValidImportStudentList.push(formattedData);
          }
          this.csvHashContent.push(formattedData);
        }
      }
      if (this.inValidImportStudentList.length > 0) {
        this.dismissBulkRegistrationPopup();
        this.$refs['popup_import_failed'].show();
        return;
      }
      this.$logger.debug('Data ready', this.csvHashContent);
    },
    checkValidPassword(password) {
      const regexPattern = /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z0-9]{4,}$/;
      return regexPattern.test(password);
    },
    async importStudents() {
      this.$logger.debug('Data to import: ' + this.csvHashContent);
      this.startImportingStudents(this.csvHashContent)
        .then((response) => {
          this.csvHashContent = [];
          this.$logger.debug('Import Students successfully with response: ' + response);
          this.$router.push({ name: 'student-import' });
        })
        .catch((error) => {
          this.$logger.debug('Import Students failed with response: ' + error);
        });
    },
    bulkRegistration() {
      this.$logger.debug('Display bulk registration Popup');
      this.$refs['bulk_registration'].show();
    },
    dismissBulkRegistrationPopup() {
      this.$logger.debug('Dismiss registration Popup');
      this.csvHashContent = [];
      this.$refs['bulk_registration'].hide();
    },
    experienceRegistration() {
      this.$logger.debug('Redirect to Experience ID registration page');
      this.$router.push({ name: 'trial-student-registration' });
    },
    notSelectedConfirmed() {
      this.$logger.debug('Not Selected Confirmed Popup done');
    },
    upgradeLevelErrorConfirmed() {
      this.$logger.debug('Upgrade Level Error Popup done');
    },
    downgradeLevelErrorConfirmed() {
      this.$logger.debug('Downgrade Level Error Popup done');
      this.$refs['select_downgrade_level'].show();
    },
    deactivateErrorConfirmed() {
      this.$logger.debug('Deactivate Error Popup done');
      this.$refs['selected_function'].show();
    },
    changeNextFiguredTeachingMaterialErrorConfirmed() {
      this.$logger.debug('Change Next Figured Teaching Material Error Popup done');
      this.$refs['selected_function'].show();
    },
    bulkRegistrationConfirmed() {
      if (this.csvHashContent.length > 0) {
        this.$logger.debug('Bulk Registration Confirmed Popup done');
        this.importStudents();
      } else {
        this.$logger.debug('No data to import');
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
    },
    async loadNewData() {
      // Set Params
      const limit = this.perPage;
      const offset = this.offset;
      const params = { limit: limit, offset: offset, setBusy: true };

      // Add filterBy
      if (this.appliedFilterBy) params.filterBy = this.appliedFilterBy;
      // If the conditions for filterBy changed but not applied, display the applied conditions.
      this.displayAppliedFilterIfAny();

      // Add orderBy and orderDir (orderDirection: ASC or DESC)
      if (this.appliedOrderBy) {
        params.orderBy = this.appliedOrderBy.orderBy;
        params.orderDir = this.appliedOrderBy.orderDir;
      }
      // If the conditions for orderBy changed but not applied, display the applied conditions.
      this.displayAppliedOrderIfAny();
      this.pagingLoadingDone = false;

      // Load the student data depends on the current tab
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          await this.loadNormalStudents(params);
          this.$logger.debug('Loaded the next loadNormalStudents.');
          break;
        case this.TABS.TRIAL_ACCOUNT:
          await this.loadTrialStudents(params);
          this.$logger.debug('Loaded the next loadTrialStudents.');
          break;
        case this.TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT:
          await this.loadClosedOrPreRegistrationStudents(params);
          this.$logger.debug('Loaded the next loadTrialSloadClosedOrPreRegistrationStudentstudents.');
          break;
        default:
          break;
      }

      this.pagingLoadingDone = true;
    },
    async goToPreviousPage() {
      this.selectAll = false;
      this.currentPage--;
      if (this.offset - this.perPage < 0) this.offset = 0;
      else this.offset = this.offset - this.perPage;

      await this.loadNewData();
      this.syncCurrentPageCount();
    },
    async goToNextPage() {
      this.selectAll = false;
      this.currentPage++;
      this.offset = this.offset + this.perPage;

      await this.loadNewData();
      this.syncCurrentPageCount();
    },
    async goToFirstPage() {
      this.selectAll = false;
      this.currentPage = 1;
      this.offset = 0;

      this.syncCurrentPageCount();
    },
    syncCurrentPageCount() {
      switch (this.currentTab) {
        case this.TABS.NORMAL_ACCOUNT:
          this.currentStudentPage = this.currentPage;
          break;
        case this.TABS.TRIAL_ACCOUNT:
          this.currentTrialStudentPage = this.currentPage;
          break;
        case this.TABS.CLOSED_OR_PRE_REGISTRATION_ACCOUNT:
        default:
          this.currentCloseOrPreRegistrationStudentPage = this.currentPage;
          break;
      }
    },
    goToPreviousPageSelected() {
      this.currentPageSelected--;
    },
    goToNextPageSelected() {
      this.currentPageSelected++;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.$refs['student-table'].selectAllRows();
      } else {
        this.$refs['student-table'].clearSelected();
      }
    },
    selectRow(checked, index) {
      if (checked) {
        this.$refs['student-table'].selectRow(index);
      } else {
        this.$refs['student-table'].unselectRow(index);
      }
    },
    basicPresent(field) {
      return basicPresent(field);
    },
    preRegistrationDatetimePresent(field) {
      return basicJapaneseYearMonth(field);
    },
    deactivatedDatetimePresent(field) {
      return basicJapaneseYearMonth(field);
    },
    reactivatedDatetimePresent(field) {
      return basicJapaneseYearMonth(field);
    },
    trialExpirationDatetimePresent(field) {
      return basicDate(field);
    },
    remainingDaysToDeletePresent(student) {
      return remainingDaysToDeletePresent(student);
    },
    findUpdateLevel(levels) {
      let code = this.selectedMaterialLevel.materialCode;
      console.log(levels);
      console.log(this.selectedMaterialLevel);
      let level = find(levels, (level) => level.position == this.selectedMaterialLevel.levelPosition);
      if (code == '100') {
        level = find(level.subLevels, (subLevel) => subLevel.position == this.selectedMaterialLevel.subLevelPosition);
      }
      return level;
    },
    levelDisplay(levels) {
      const level = this.findUpdateLevel(levels);
      return basicLevelDisplay(level.name);
    },
    postLevelUpdateDisplay(levels) {
      // after upgrade or downgrade, post level will be the new pre level
      return this.levelDisplay(levels);
    },
    expectedLevelUpgradeDisplay(levels) {
      let level = this.findUpdateLevel(levels);
      let levelDisplay = null;
      if (!isEmpty(level.nextLevel)) {
        levelDisplay = level.nextLevel.name;
      }
      return basicLevelDisplay(levelDisplay);
    },
    expectedLevelDowngradeDisplay(levels) {
      let level = this.findUpdateLevel(levels);
      let levelDisplay = null;
      if (!isEmpty(level.previousLevel)) {
        levelDisplay = level.previousLevel.name;
      }
      return basicLevelDisplay(levelDisplay);
    },
    preRegistrationStatusDisplay(student) {
      return preRegistrationStatusDisplay(student);
    },
    nextPreRegistrationStatusDisplay(student) {
      if (student.reactivatedDatetime) {
        return basicJapaneseYearMonth(student.reactivatedDatetime);
      } else if (student.preRegistrationDatetime) {
        return basicJapaneseYearMonth(student.preRegistrationDatetime);
      } else if (student.deactivated) {
        return '休会中';
      } else if (student.preRegistration) {
        return '仮登録';
      }
      return '今すぐ利用開始';
    },
    preRegistrationDateStatusDisplay(student) {
      return preRegistrationDateStatusDisplay(student);
    },
    figuredShapeTeachingMaterialDisplay(currentLevelMaterials) {
      return basicTeachingMaterialShapeDisplay(currentLevelMaterials);
    },
    figuredAlgebraTeachingMaterialDisplay(currentLevelMaterials) {
      return basicTeachingMaterialAlgebraDisplay(currentLevelMaterials);
    },
    figuredJapaneseTeachingMaterialDisplay(currentLevelMaterials) {
      return basicTeachingMaterialJapaneseDisplay(currentLevelMaterials);
    },
    figuredKidsMathematicsTeachingMaterialDisplay(currentLevelMaterials) {
      return basicTeachingMaterialKidsMathematicsDisplay(currentLevelMaterials);
    },
    figuredAdvancedMathematicsTeachingMaterialDisplay(currentLevelMaterials) {
      return basicTeachingMaterialAdvancedMathematicsDisplay(currentLevelMaterials);
    },
    nextFiguredTeachingMaterialMonth(id) {
      return basicNextTeachingMaterialMonth(id);
    },
    showLearningHistory(id) {
      this.$logger.debug('Show Learning History ID ' + id);
      this.$router.push({ name: 'student-id-history', params: { id: id } });
    },
    exportToExcel() {
      this.$logger.debug('Export Students to Excel');
      let data = this.getExcelFormattedStudents(this.currentStudents, this.selectedFieldLabels);
      var studentWS = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, studentWS, 'Students'); // add Worksheet to Workbook
      XLSX.writeFile(wb, 'students.xlsx');
    },
    createHeaders(keys, columnWidth) {
      this.$logger.debug('columnWidth', columnWidth);
      return keys.map((key) => ({
        name: key,
        prompt: key,
        width: columnWidth,
        align: 'left',
        padding: 0,
      }));
    },
    exportToPdf() {
      this.$logger.debug('Print Students to PDF');
      let doc = new jsPDF({ orientation: 'l', unit: 'mm', format: 'a4' });
      buildJapaneseFont(doc);
      // When logged in with a Teacher ID, selectedFieldLabels contains 学習履歴. This should be removed here.
      const filteredFields = this.selectedFieldLabels.filter((field) => field !== '学習履歴');
      let data = this.getExcelFormattedStudents(this.currentStudents, filteredFields);
      let pdfPageWidth = doc.internal.pageSize.getWidth();

      // Setting the actual pdfPageWidth doesn't fill the entire page,
      // so use a bigger number as a workaround when there are many columns.
      let paddingWidth = 4;
      if (this.selectedFieldLabels.length > 6) {
        pdfPageWidth = 390;
        paddingWidth = 2;
      }
      let columnWidth = (pdfPageWidth - paddingWidth * 2) / filteredFields.length;
      doc.table(paddingWidth, 6, data, this.createHeaders(filteredFields, columnWidth));
      doc.autoPrint();
      if (data.length > 50) {
        this.$logger.debug('Data too big, can only save');
        doc.save('students.pdf', { returnPromise: true }).then(() => {
          this.$logger.debug('PDF saved successfully');
        });
      } else {
        this.$logger.debug('Data OK, Print from new window');
        doc.output('dataurlnewwindow', { filename: 'students.pdf' });
      }
    },
    pickedCorporation() {
      if (this.selectedCorporation) {
        this.$logger.debug('Picked Corporation: ' + this.selectedCorporation);
        this.fetchBrands({ data: { filterBy: { corporationId: this.selectedCorporation } } });
        this.$logger.debug('Fetch Brands for the search bar');
      }

      this.selectedBrand = null;
      this.selectedSchool = null;
      this.clearBrands();
      this.clearSchools();
    },
    pickedBrand() {
      if (this.selectedBrand) {
        this.$logger.debug('Picked Brand: ', this.selectedBrand);
        this.fetchSchools({ data: { filterBy: { brandId: this.selectedBrand } } });
        this.$logger.debug('Fetch Schools for the search bar');
      }

      this.selectedSchool = null;
      this.clearSchools();
    },
    async getOwnProducts() {
      if (this.hasAdminPrivilege) {
        await this.fetchProducts();
        return this.product.products;
      } else if (this.hasCorporationPrivilege) {
        return this.corporation.corporation.figuredProducts;
      } else if (this.hasBrandPrivilege) {
        return this.brand.brand.corporation.figuredProducts;
      } else if (this.hasSchoolPrivilege) {
        return this.school.school.corporation.figuredProducts;
      } else if (this.hasTeacherPrivilege) {
        return this.teacher.teacher.corporation.figuredProducts;
      }
    },
    async filterTeachingMaterialsByProducts() {
      const allTeachingMaterials = this.teachingMaterials;
      const userProducts = await this.getOwnProducts();
      const userTeachingMaterials = filterTeachingMaterialsByProducts(allTeachingMaterials, userProducts);
      return userTeachingMaterials;
    },
    hasSelectedNextTeachingMaterial(nextTeachingMaterialArray = []) {
      if (nextTeachingMaterialArray.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    ...mapActions('student', [
      'clearEditingStudent',
      'storeSelectedStudents',
      'cleanSelectedStudents',
      'clearEditingStudentAffiliation',
      'deactivateStudents',
      'reactivateStudents',
      'upgradeLevelStudents',
      'downgradeLevelStudents',
      'upgradeFiguredTeachingMaterial',
      'upgradeNextFiguredTeachingMaterial',
      'upgradeImmediateNextFiguredTeachingMaterial',
      'clearNextFiguredTeachingMaterial',
      'changePreRegistrationTime',
      'clearPreRegistrationTime',
      'resetPasswordAndExportPdf',
      'fetchStudents',
      'fetchTrialStudents',
      'fetchClosedOrPreRegistrationStudents',
    ]),
    ...mapActions('student_importer', ['startImportingStudents']),
    ...mapActions('corporation', ['fetchCorporations']),
    ...mapActions('brand', ['fetchBrands', 'clearBrands']),
    ...mapActions('school', ['fetchSchools', 'clearSchools']),
    ...mapActions('product', ['fetchProducts']),
  },
};
</script>

<style scoped>
.nav-cursor {
  cursor: pointer;
}
.small-text {
  margin-left: 6px;
}
.small-sub-text {
  display: block;
  margin-left: 18px;
}
.btn-gray {
  margin-bottom: 5px;
}
.item-count {
  padding: 0;
  font-size: 10px;
}
.custom-control-label {
  font-weight: normal;
}
.pagination-footer {
  margin-top: 20px;
}
.btn-confirm-bulk {
  margin-right: 0px;
  margin-bottom: 0px;
}

/* CSS for Search Feature */
.search-box-container {
  justify-content: space-between;
  display: flex;
}
.search-box-left {
  width: 49%;
  text-align: left;
}
.search-box-right {
  width: 50%;
  text-align: right;
}
#searchDropdownMenuButton {
  background-color: white;
  color: #707070;
  font-size: 13px;
  padding-top: 1px;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 2px;
}
.search-box-right table,
.search-box-left table {
  width: 100%;
  border-spacing: 0 3px;
  border-collapse: separate;
}
.search-box-left table td,
.search-box-right table td {
  padding: 0px 0px 0px 0px;
  vertical-align: top;
}
.search-box-right .form-control {
  width: 100%;
}
.form-search-button {
  width: 100%;
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
}
.search-box-right #searchform_small,
.search-box-right .btn-sm {
  margin-left: 0px;
  width: 100%;
  float: none;
}
.caution span {
  color: red;
}
.radio .radio-input {
  margin-right: 5px;
}
.downgrade-level-radio-group {
  margin-left: 40px;
}
</style>
